import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useHistory } from "react-router-dom";
import { Button, Modal, Form, Row, Col, Tabs, Tab, InputGroup } from "react-bootstrap";
import {
  Paper,
  TextField,
  Grid,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Tooltip,
  makeStyles,
  Typography,
  Switch,
  FormControlLabel,
} from "@material-ui/core";
import { DataGridPro } from "@mui/x-data-grid-pro";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import CopyIcon from "@material-ui/icons/FileCopyOutlined";
// import ForumIcon from '@material-ui/icons/Forum';
import CloseIcon from "@material-ui/icons/Close";
import { Formik } from "formik";
import BookingsList from "../../../components/BookingsList";
import FormDataEntry from "../admin/FormDataEntry";
// import MoveToInboxIcon from '@material-ui/icons/MoveToInbox';
// import LabelOutlinedIcon from '@material-ui/icons/LabelOutlined';
import * as Admin from "../../../store/ducks/admin.duck";
import * as Reference from "../../../store/ducks/reference.duck";
import * as Registration from "../../../store/ducks/registration.duck";
import PlacesAutoComplete from "../../../components/AddressAutoComplete";
import { BookingWeek } from "../../../components/Appointments";
import AuditLog from "../../../components/AuditLog";
import * as Yup from "yup";
import Notes from "../../../components/Notes";
import Files from "../../../components/Files";
import BookingLink from "../../../components/bookingLink";
import BookingOutcome from "../../../components/BookingOutcome";
import ClientScores from "../../../components/ClientScores";
import { ToastContainer, Flip } from "react-toastify";
import { format, differenceInYears } from "date-fns";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../../_metronic/_assets/css/app.css";
import "../../../../_metronic/_assets/css/app2.css";

const useStyles = makeStyles((theme) => ({
  noBorder: {
    border: "none",
  },
  formControl: {
    margin: 0, //theme.spacing(1),
    minWidth: 120,
  },
  formControlWide: {
    margin: 0, //theme.spacing(1),
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  label: {
    backgroundColor: "#fff",
    paddingLeft: 3,
    paddingRight: 3,
  },
}));

const fieldLabels = {
  firstname: "Personal Tab - First Name",
  preferredname: "Personal Tab - Preferred Name",
  surname: "Personal Tab - Surname",
  dob: "Personal Tab - Date of Birth",
  email: "Personal Tab - Email",
  mobilephone: "Personal Tab - Mobile Phone",
  fulladdress: "Personal Tab - Address",
  pronouns: "Pronouns",

  referralPurpose: "Referral Tab - Purpose of Referral",
  medication: "Referral Tab - Current Medication",
  hopeToGetFromTreatment: "Referral Tab - Presenting concerns & relevant background",
  identifiedRisksAndAgreedManagement: "Referral Tab - Identified Risks and Agreed Management",
  csSessionExpectation: "Referral Tab - Estimated Total Number of Sessions",
  estimatedEndOfCareDate: "Referral Tab - Centre Anticipated End of Care Date",

  emergencycontactname1: "Personal Tab - Emergency Contact Name",
  emergencycontactrelation1: "Personal Tab - Emergency Contact Relationship",
  emergencycontactphone1: "Personal Tab - Emergency Contact Phone",

  emergencycontactname2: "Personal Tab - Second Emergency Contact Name",
  emergencycontactrelation2: "Personal Tab - Second Emergency Contact Relationship",
  emergencycontactphone2: "Personal Tab - Second Emergency Contact Phone",

  centreClientId: "Personal Tab - Case Number",
  csCentreID: "Personal Tab - Centre",

  gpName: "GP Tab - GP Name",
  gpClinicName: "GP Tab - GP Clinic Name",
  gpContactNumber: "GP Tab - GP Contact Phone",
};

export default function CSClients(props) {
  const dispatch = useDispatch();
  const contexts = useSelector((state) => state.reference.Contexts);
  const history = useHistory();

  const clients = useSelector((state) => state.admin.CSClients);
  const filters = useSelector((state) => state.admin.Filters);
  const bookings = useSelector((state) => state.admin.Bookings);
  const clientBooking = useSelector((state) => state.admin.Booking);
  const languages = useSelector((state) => state.reference.Languages);
  const countries = useSelector((state) => state.reference.Countries);
  const thisClient = useSelector((state) => state.admin.CSClient);
  const role = useSelector((state) => state.auth.roleDesc);
  const rolescope = useSelector((state) => state.auth.roleScope);
  const [sortModel, setSortModel] = useState([{ field: "createdon", sort: "desc" }]);

  const [key, setKey] = React.useState("Personal");
  const originalClient = useRef(null);
  var [showBooking, setShowBooking] = useState(false);
  var [showConsentForm, setShowConsentForm] = useState(false);
  var [showLink, setShowLink] = useState(false);
  var [consentFormData, setConsentFormData] = useState();

  var [toggleMessage, setToggleMessage] = useState(false);
  var [newNote, setNewNote] = useState("");
  var [sentMsg, setSentMsg] = useState();
  var [showAttendanceDialog, setShowAttendanceDialog] = useState(false);
  var [attendanceStatus, setAttendanceStatus] = useState("");

  const getProviderIds = (currentprovider) => {
    if (!currentprovider) return [];

    // Already an array (new API behavior)
    if (Array.isArray(currentprovider)) {
      return currentprovider.map(Number).filter(Number.isFinite);
    }

    // JSON string "[1,2,3]"
    if (typeof currentprovider === "string" && currentprovider.trim().startsWith("[")) {
      try {
        return JSON.parse(currentprovider).map(Number).filter(Number.isFinite);
      } catch {
        return [];
      }
    }

    // Comma-separated string "1,2,3"
    if (typeof currentprovider === "string") {
      return currentprovider
        .split(",")
        .map((s) => Number(s.trim()))
        .filter(Number.isFinite);
    }

    return [];
  };

  const searchClients = (client) => {
    if (
      true &&
      (client.fullname.toLowerCase().search(filters.clientsTerm.toLowerCase()) > -1 ||
        client.flagClean.toLowerCase().search(filters.clientsTerm.toLowerCase()) > -1 ||
        (client.psychologistName && client.psychologistName.toLowerCase().search(filters.clientsTerm.toLowerCase()) > -1) ||
        filters.clientsTerm.length === 0) &&
      (!filters.csCentre || filters.csCentre === "All" || (filters.csCentre && String(client.centreId) === String(filters.csCentre.id))) &&
      (!filters.clientsPsychologist ||
        filters.clientsPsychologist === "All" ||
        (filters.clientsPsychologist && getProviderIds(client.currentprovider).includes(filters.clientsPsychologist.id))) &&
      // && (filters.clientsFlags === 'All' || (client.clientRegistrationID === null && filters.clientsFlags === 'Self-registered'))
      // Removed for performance reasons && (filters.clientsAOI === '' || client.clientAreasOfInterest.some(issue => issue === filters.clientsAOI))
      (filters.clientsStatus === "All" ||
        (filters.clientsStatus === "Active" && client.status === "Active") ||
        (filters.clientsStatus === "Archived" && client.status === "Archived") ||
        (filters.clientsStatus === "Closed" && client.status === "Closed")) &&
      // && (filters.clientsSpecialisationType === 'All' || (client.specialisttype === filters.clientsSpecialisationType))
      (!filters.clientsColour || filters.clientsColour === "All" || client.listcolor === filters.clientsColour) &&
      (filters.clientsAOI === "All" || (client.clientaoi && client.clientaoi.length > 0 && client.clientaoi.some((issue) => issue === filters.clientsAOI)))
    ) {
      return client;
    }
  };

  const filteredClients = useMemo(() => clients.filter((client) => searchClients(client)), [clients, filters]);

  useEffect(() => {
    dispatch(Admin.actions.fetchCsAgents());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchCsCentres());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchRegistered());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Reference.actions.fetchTimeZone());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Reference.actions.fetchLanguages());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Reference.actions.fetchCountries());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Reference.actions.fetchConstants());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Reference.actions.fetchSundayThisWeek());
  }, [dispatch]);
  // useEffect( () => { dispatch(Reference.actions.fetchAreasOfInterest({providerType:'ALL', centralisedservice: true})) }, [dispatch] )
  useEffect(() => {
    contexts && contexts.length < 1 && dispatch(Reference.actions.fetchContexts());
  }, [dispatch, contexts]);

  const actualRegistered = useSelector((state) => state.admin.RegisteredPsychologists);
  const registeredPsychologists = actualRegistered.filter((psychologist) => psychologist.specialisttype === "centralisedservice");
  const timeZone = useSelector((state) => state.reference.TimeZone);
  const centreName = useSelector((state) => state.auth.centreName);
  const currentAgentID = useSelector((state) => state.auth.csAgentID);
  const csCentres = useSelector((state) => state.admin.CsCentres);
  const browserTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const browserTZMS =
    timeZone && timeZone.some((tz) => tz.ianaName === browserTZ) ? timeZone.find((tz) => tz.ianaName === browserTZ) : timeZone.find((tz) => tz.tzIndex === "6");
  const csAgents = useSelector((state) => state.admin.CsAgents);

  // Email Duplicate Check
  const [emailIsDuplicate, setEmailIsDuplicate] = useState(false);
  const emailDuplicate = useSelector((state) => state.registration.EmailDuplicate);

  const checkEmailDuplicate = useCallback(
    (newEmailDuplicate) => {
      setEmailIsDuplicate(newEmailDuplicate === true);
      dispatch(Registration.actions.emailDuplicateClear());
    },
    [dispatch],
  );

  useEffect(() => {
    //
    // Some Commentary about this
    // Essentially when someone creates a submits a form, a processing window appears and disappears once the form is processed
    // To do this a Redux variable - <formtype>Form  is set with a number - null is not set, 1 is processing and 2 is an error state
    //
    if (emailDuplicate) {
      checkEmailDuplicate(emailDuplicate);
    }
  }, [emailDuplicate, checkEmailDuplicate]);

  const initClient = useMemo(
    () => ({
      id: 0,
      timezone: browserTZMS && browserTZMS.systemName,
      status: "Active",
      // Current Psychologist
      currentprovider: "",
      // Current Centre
      csCentreID: 0,
      clientID: 0,
      owner: currentAgentID ? currentAgentID : 0,
      csSessionExpect: 0,
      csSessionExpectComment: "",
      // Booking Information
      estimatedEndOfCare: "-",
      estimatedSessions: "-",
      attendedSessions: "-",
      cancelledSessions: "-",
      futureSessions: "-",
      // Consent
      csConsent: "",
      csConsentStatus: "Not Provided",
      // Name Information
      firstname: "",
      preferredname: "",
      surname: "",
      pronouns: "",
      // Contact Information
      email: "",
      mobilephone: "",
      // Other Personal Information
      dob: undefined,
      gender: "Prefer not to say",
      // Address Information
      fulladdress: "",
      postcode: "",
      latitude: "",
      longitude: "",
      // Emergency Contact Information
      emergencycontactname1: "",
      emergencycontactphone1: "",
      emergencycontactrelation1: "",
      emergencycontactname2: "",
      emergencycontactphone2: "",
      emergencycontactrelation2: "",
      // GP Information
      gpName: "",
      gpClinicName: "",
      gpContactNumber: "",
      // Other fields
      medication: "",
      hopeToGetFromTreatment: "",
      centreClientId: "",
      appointmenttype: "0",
      translator: "No",
      translatorlanguage: "",
      supportPerson: "No",
      supportPersonDetail: "",
      // Demographic Information
      aboriginal: "4",
      homelessness: "3",
      labour: "1",
      lgbtiqa: "1",
      education: "6",
      disabilityStatus: "No",
      disabilityType: "",
      birthCountry: 1101,
      language: 13121113,
      proficiency: "0",
      testClient: "0",
      notificationPreference: "BOTH",
    }),
    [browserTZMS, currentAgentID],
  );

  var [currentClientID, setcurrentClientID] = useState();
  var [currentFirstName, setcurrentFirstName] = useState();
  var [currentPreferredName, setcurrentPreferredName] = useState();
  var [currentSurname, setcurrentSurname] = useState();
  var [currentPaymentType, setcurrentPaymentType] = useState();
  var [currentwaitingRoomURL, setcurrentwaitingRoomURL] = useState("");
  var [currentEmail, setcurrentEmail] = useState();
  var [currentMobilePhone, setcurrentMobilePhone] = useState();
  var [currentNotificationPreference, setcurrentNotificationPreference] = useState();
  var [currentTimeZone, setcurrentTimeZone] = useState();
  var [currentClientBookingType, setcurrentClientBookingType] = useState();
  var [client, setClient] = useState(initClient);
  var [currentNotesViewType, setcurrentNotesViewType] = useState("ALL");
  var [currentOwnerName, setcurrentOwnerName] = useState("");
  var [currentOwnerEmail, setcurrentOwnerEmail] = useState("");
  var [currentOwnerPhone, setcurrentOwnerPhone] = useState("");
  var [currentProviderName, setcurrentProviderName] = useState("");
  var [currentClientBooking, setcurrentClientBooking] = useState("");
  var [consentAccepted, setConsentAccepted] = useState(false);
  var [resetConsent, setResetConsent] = useState(false);
  var [currentProviderPsychologistID, setcurrentProviderPsychologistID] = useState();
  var [currentProviderPsychiatristID, setcurrentProviderPsychiatristID] = useState();
  var [currentProviderType, setcurrentProviderType] = useState();

  var [show, setShow] = useState(false);
  var [showAppointment, setShowAppointment] = useState(false);
  var [showNotes, setShowNotes] = useState(false);
  var [showFiles, setShowFiles] = useState(false);
  var [showOwner, setShowOwner] = useState(false);
  // Closure Fields
  var [currentK10Required, setcurrentK10Required] = useState(true);
  var [currentK5Required, setcurrentK5Required] = useState(false);
  var [currentSurveyRequired, setcurrentSurveyRequired] = useState(true);
  var [showClose, setShowClose] = useState(false);
  // Closure V2 Fields
  var [showCloseV2, setShowCloseV2] = useState(false);
  var [currentClosureExperienceRating, setcurrentClosureExperienceRating] = useState(0);
  var [currentReasonClosure, setcurrentReasonClosure] = useState(1);
  var [currentConsumerExperienceSurvey, setcurrentConsumerExperienceSurvey] = useState("");
  var [currentClosureFinalAssessment, setcurrentClosureFinalAssessment] = useState("");
  var [currentConsumerExperienceSurveyUpload, setcurrentConsumerExperienceSurveyUpload] = useState(null);
  // Registration Field
  var [currentRegistrationStepCompleted, setcurrentRegistrationStepCompleted] = useState(3);

  function handleClose() {
    setShow(false);
    // Clear Client Selection in state
    dispatch(Admin.actions.clearCSClient());
  }

  function handleCloseClose() {
    setShowClose(false);
  }

  function handleAppointmentClose() {
    setShowAppointment(false);
  }

  const handleConsentAction = (selectedValue) => {
    // Handle the action required for consent
    switch (selectedValue) {
      case "FormNow":
        displayConsentForm();
        break;
      case "FormOnSave":
        sendConsentEmail();
        break;
      case "Download":
        downloadConsentForm();
        break;
    }
  };

  const displayConsentForm = () => {
    // console.log("Displaying consent form...");
    setShowConsentForm(true);
    setConsentAccepted(true); // Assume consent accepted if form is shown
  };

  const sendConsentEmail = () => {
    // console.log("Sending email with consent form...");
    setConsentAccepted(true);
  };

  const downloadConsentForm = async () => {
    window.open("https://files.ruralhealthconnect.com.au/filestoreRHC//CSConsentForm.pdf", "_blank");
    setConsentAccepted(true);
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  function putClient(data) {
    const formData = new FormData();

    // Helper function to append safely
    const appendField = (key, value) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    };

    // Basic Info
    appendField("id", data.id || 0);
    appendField("status", data.status || "Active");
    appendField("previousstatus", data.previousstatus);

    // Name
    appendField("firstname", data.firstname);
    appendField("preferredname", data.preferredname);
    appendField("surname", data.surname);
    appendField("pronouns", data.pronouns);

    // Contact
    appendField("email", data.email);
    appendField("mobilephone", data.mobilephone);

    // Personal
    appendField("dob", data.dob);
    appendField("gender", data.gender);

    // Address
    appendField("fulladdress", data.fulladdress);
    appendField("postcode", data.postcode);
    appendField("latitude", data.latitude);
    appendField("longitude", data.longitude);

    // Emergency Contacts
    appendField("emergencycontactname1", data.emergencycontactname1);
    appendField("emergencycontactphone1", data.emergencycontactphone1);
    appendField("emergencycontactrelation1", data.emergencycontactrelation1);
    appendField("emergencycontactname2", data.emergencycontactname2);
    appendField("emergencycontactphone2", data.emergencycontactphone2);
    appendField("emergencycontactrelation2", data.emergencycontactrelation2);

    // GP
    appendField("gpName", data.gpName);
    appendField("gpClinicName", data.gpClinicName);
    appendField("gpContactNumber", data.gpContactNumber);

    // Other
    appendField("timezone", data.timezone);
    appendField("appointmenttype", data.appointmenttype);
    appendField("notificationPreference", data.notificationPreference);
    appendField("translator", data.translator);
    appendField("translatorlanguage", data.translatorlanguage);
    appendField("supportPerson", data.supportPerson);
    appendField("supportPersonDetail", data.supportPersonDetail);
    appendField("currentprovider", data.currentprovider || "");
    appendField("listcolor", data.listcolor || "Black");
    appendField("testClient", data.testClient || "0");

    // Additional
    appendField("medication", data.medication);
    appendField("hopeToGetFromTreatment", data.hopeToGetFromTreatment);
    appendField("referralPurpose", data.referralPurpose);
    appendField("referralInformation", data.referralInformation);
    appendField("identifiedRisksAndAgreedManagement", data.identifiedRisksAndAgreedManagement || "");
    appendField("specialCircumstances", data.specialCircumstances || "");
    appendField("estimatedEndOfCareDate", data.estimatedEndOfCareDate || "");
    appendField("csSessionExpectation", data.csSessionExpectation || 0);

    // CS
    appendField("centreClientId", data.centreClientId);
    appendField("csCentreID", data.csCentreID);
    appendField("owner", data.owner);
    appendField("csConsent", data.csConsent);
    appendField("csConsentFormData", JSON.stringify(consentFormData));

    // Demographic
    appendField("aboriginal", data.aboriginal);
    appendField("homelessness", data.homelessness);
    appendField("labour", data.labour);
    appendField("lgbtiqa", data.lgbtiqa);
    appendField("education", data.education);
    appendField("disabilityStatus", data.disabilityStatus);
    appendField("disabilityType", data.disabilityType);
    appendField("birthCountry", data.birthCountry);
    appendField("language", data.language);
    appendField("proficiency", data.proficiency);

    // Registration Process
    appendField("csRegistrationStepCompleted", data.csRegistrationStepCompleted || 3);

    // ✅ FILE FIELD (important)
    if (data.recentIARFile) {
      formData.append("RecentIARFile", data.recentIARFile);
    }

    if (process.env.REACT_APP_DEBUG) {
      console.log("Saving FormData");
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }
    }

    dispatch(Admin.actions.putCSClient({ formData }));
    setShow(false);
  }

  function loadNotes(thisClient, viewType) {
    setcurrentClientID(thisClient.id);
    setcurrentFirstName(thisClient.firstname);
    setcurrentPreferredName(thisClient.preferredname);
    setcurrentSurname(thisClient.surname);
    setcurrentwaitingRoomURL(thisClient.waitingRoomURL);
    setcurrentNotesViewType(viewType);
    setcurrentOwnerName(
      csAgents && csAgents.some((agent) => agent.id === thisClient.ownerid) ? csAgents.find((agent) => agent.id === thisClient.ownerid).firstname : "",
    );
    setcurrentEmail(thisClient.email);
    setcurrentMobilePhone(thisClient.mobilephone);
    // setcurrentReferralGPName(thisClient.referringGPName)
    // setcurrentReferralGPPracticeFax(thisClient.referralGPPracticeFax)
    // setcurrentReferralGPPracticeEmail(thisClient.referralGPPracticeEmail)
    setShowNotes(true);
  }

  function loadLink(thisClient) {
    setcurrentClientID(thisClient.id);
    setcurrentFirstName(thisClient.firstname);
    setcurrentPreferredName(thisClient.preferredname);
    setcurrentSurname(thisClient.surname);
    setcurrentEmail(thisClient.email);
    setcurrentMobilePhone(thisClient.mobilephone);
    // Determine which is the next appointment
    const now = new Date();

    const psychDate = thisClient.topBookingPsy ? new Date(thisClient.topBookingPsy) : null;

    const psychiatristDate = thisClient.topBookingPsychiatrist ? new Date(thisClient.topBookingPsychiatrist) : null;

    let nextBooking = null;

    // 1️⃣ Only psychologist exists
    if (psychDate && !psychiatristDate) {
      nextBooking = "Psychologist";

      // 2️⃣ Only psychiatrist exists
    } else if (!psychDate && psychiatristDate) {
      nextBooking = "Psychiatrist";

      // 3️⃣ Both exist
    } else if (psychDate && psychiatristDate) {
      const psychInFuture = psychDate > now;
      const psychiatristInFuture = psychiatristDate > now;

      if (psychInFuture && psychiatristInFuture) {
        // both future → earliest
        nextBooking = psychDate < psychiatristDate ? "Psychologist" : "Psychiatrist";
      } else if (psychInFuture) {
        nextBooking = "Psychologist";
      } else if (psychiatristInFuture) {
        nextBooking = "Psychiatrist";
      } else {
        // both past → most recent
        nextBooking = psychDate > psychiatristDate ? "Psychologist" : "Psychiatrist";
      }
    }
    // Ok using this information set up the link details
    if (nextBooking === "Psychiatrist") {
      setcurrentClientBookingType(thisClient.nextBookingTypePsychiatrist === "1" ? "PHONE" : "VIDEO");
      setcurrentwaitingRoomURL(thisClient.psychiatristWaitingRoomURL);
      setcurrentProviderName(thisClient.psychiatristName);
      setcurrentClientBooking(format(new Date(thisClient.topBookingPsychiatrist), "dd-MM-yyyy HH:mm aa"));
    } else if (nextBooking === "Psychologist") {
      setcurrentClientBookingType(thisClient.nextBookingTypePsych === "1" ? "PHONE" : "VIDEO");
      setcurrentwaitingRoomURL(thisClient.waitingRoomURL);
      setcurrentProviderName(thisClient.psychologistName);
      setcurrentClientBooking(format(new Date(thisClient.topBookingPsy), "dd-MM-yyyy HH:mm aa"));
    }
    setShowLink(true);
  }

  function handleCloseClose() {
    setShowClose(false);
  }

  const handleK10Toggle = (checked) => {
    setcurrentK10Required(checked);
    // if (!checked) {
    //   // if K10 turned off, automatically enable K5
    //   setcurrentK5Required(true);
    // }
    // else {
    //   // if K10 turned on, automatically disable K5
    //   setcurrentK5Required(false);
    // }
  };

  const handleK5Toggle = (checked) => {
    setcurrentK5Required(checked);
    // if (!checked) {
    //   // if K5 turned off, automatically enable K10
    //   setcurrentK10Required(true);
    // }
    // else {
    //   // if K5 turned on, automatically disable K10
    //   setcurrentK10Required(false);
    // }
  };

  function loadFiles(thisClient) {
    setcurrentClientID(thisClient.id);
    setcurrentPaymentType(thisClient.paymentType);
    setcurrentFirstName(thisClient.firstname);
    setcurrentPreferredName(thisClient.preferredname);
    setcurrentSurname(thisClient.surname);
    setShowFiles(true);
  }

  function closeClient(thisClient) {
    // Display modal to confirm closing client
    // Need to load client
    dispatch(Admin.actions.fetchCSClient({ clientID: thisClient.id }));
    history.push("/csclientclose");
    return;
  }

  function closeClientUpdate(clientID, firstname, email, surveyRequired, k10Required, k5Required) {
    // Alters client to Closed status and sends survey in the API
    dispatch(
      Admin.actions.putCSClientClose({
        clientID: clientID,
        firstname: firstname,
        email: email,
        surveyRequired: surveyRequired,
        k10Required: k10Required,
        k5Required: k5Required,
      }),
    );
    setShowClose(false);
  }

  function loadNewClient() {
    // Set step 1 to 1
    dispatch(Admin.actions.clearCSClientRegistration());
    // Clear existing client in state
    dispatch(Admin.actions.clearCSClient());
    history.push("/csclientregistration");
    return;
  }

  function loadOwner(thisClient) {
    // Look up owner in csAgents
    const owner = csAgents.find((agent) => agent.id === thisClient.ownerid);
    if (owner) {
      setcurrentOwnerName(owner.fullname);
      setcurrentOwnerEmail(owner.email);
      setcurrentOwnerPhone(owner.mobilephone);
      setShowOwner(true);
    }
  }

  const loadClient = useCallback(
    (id) => {
      setShow(true);
      // Clear reset flag
      setResetConsent(false);
      // Need to determine if the id is a number or a GUID
      if (isNaN(id)) {
        // It's a GUID
        dispatch(Admin.actions.fetchCSClient({ clientID: 0, clientGUID: id }));
      } else {
        // It's a number, so we can fetch the client directly by ID
        dispatch(Admin.actions.fetchCSClient({ clientID: id }));
      }
    },
    [dispatch],
  );

  const loadIncompleteRegistration = useCallback(
    (id, stepCompleted) => {
      // Set the step completed in the Redux state for the client registration + 1
      const newStepCompleted = stepCompleted + 1;
      dispatch(Admin.actions.putClientRegistrationStep(newStepCompleted));
      // Need to load client then go to registration page - based on the step that is incomplete
      setcurrentRegistrationStepCompleted(newStepCompleted);
      // console.log("Loading incomplete registration for client ID:", id, "Step completed:", newStepCompleted);
      dispatch(Admin.actions.fetchCSClient({ clientID: id }));
      history.push("/csclientregistration");
    },
    [dispatch],
  );

  const loadAppointment = (thisClient) => {
    // console.log("Loading appointment for client:", thisClient);
    setcurrentClientID(thisClient.id);
    setcurrentPaymentType(thisClient.paymentType);
    setcurrentFirstName(thisClient.firstname);
    setcurrentPreferredName(thisClient.preferredname);
    setcurrentSurname(thisClient.surname);
    setcurrentEmail(thisClient.email);
    setcurrentTimeZone(thisClient.timeZone);
    setcurrentwaitingRoomURL(thisClient.waitingRoomURL);
    setcurrentClientBookingType(thisClient.appointmenttype === "1" ? "PHONE" : "VIDEO");

    // Ok using this information set up the link details
    setcurrentProviderPsychiatristID(thisClient.psychiatristCurrent);
    setcurrentProviderPsychologistID(thisClient.psychologistCurrent);

    // Load Form
    setShowAppointment(true);
  };

  useEffect(() => {
    setNewNote(`Dear ${clientBooking.clientFirstName},

  Please note you have been booked for a consultation with ${clientBooking.psychologistfullname} at ${format(new Date(clientBooking.clientDate ? clientBooking.clientDate : null), "dd-MM-yyyy hh:mm aa")}. 

  Please connect here: ${clientBooking.waitingroomurl} at that time.`);
  }, [clientBooking, newNote, setNewNote]);

  const loadBooking = (thisBooking) => {
    setNewNote();
    dispatch(Admin.actions.fetchBooking({ bookingid: thisBooking }));
    setToggleMessage(false);
    setShowBooking(true);
  };

  function getActionButtons(id) {
    if (clientBooking.status === "Active") {
      return (
        <>
          <Button variant="warning" size="sm" onClick={() => markAttendance(id)}>
            Cancel Booking
          </Button>
        </>
      );
    }
  }

  const StatusFlags = ({ consentStatus, iarStatus, initialAssessmentStatus }) => {
    // This determines three statuses
    // - Consent Form Completed - C  -
    // - IAR Uplodated = I
    // - Initial Assessment Completed - A
    // Depending on which one is missing will be red or green if it exists

    return (
      <>
        <Tooltip title="Consent Status" aria-label="Consent Status" placement="top" arrow>
          <Button
            size="sm"
            variant="contained"
            style={{
              background: consentStatus === "Yes" ? "green" : "red",
              paddingLeft: 10,
              paddingRight: 10,
              minWidth: 36,
              color: "white",
            }}
          >
            C
          </Button>
        </Tooltip>
        <Tooltip title="IAR Status" aria-label="IAR Status" placement="top" arrow>
          <Button
            size="sm"
            variant="contained"
            style={{
              marginLeft: 5,
              background: iarStatus === "Yes" ? "green" : "red",
              paddingLeft: 10,
              paddingRight: 10,
              minWidth: 36,
              color: "white",
            }}
          >
            I
          </Button>
        </Tooltip>
        <Tooltip title="Initial Assessment Status" aria-label="Initial Assessment Status" placement="top" arrow>
          <Button
            size="sm"
            variant="contained"
            style={{
              marginLeft: 5,
              background: initialAssessmentStatus === "Yes" ? "green" : "red",
              paddingLeft: 10,
              paddingRight: 10,
              minWidth: 36,
              color: "white",
            }}
          >
            A
          </Button>
        </Tooltip>
      </>
    );
  };

  function markAttendance() {
    // Assumed clientbooking in state is the current booking we want to mark attendance for
    // Close appointment modal and open attendance modal
    setShowBooking(false);
    setShowAttendanceDialog(true);
    // dispatch(
    //   Admin.actions.putAppointment({
    //     id: id,
    //     status: "Cancelled",
    //     refreshPayload: { key: "client", id: currentClientID, bookingid: id },
    //   }),
    // );
    // dispatch(Admin.actions.setBookingStatus({ status: "Cancelled" }));
  }

  function sendMessage() {
    const formData = new FormData();
    // Add fields
    formData.append("type", "Client");
    formData.append("pkid", clientBooking.clientID);
    formData.append("subject", "");
    formData.append("selector", "SMS");
    formData.append("note", newNote);
    formData.append("faxdestination", "");
    formData.append("faxFile", "");
    formData.append("sendFormID", 0);
    // Ok Time to Dispatch
    process.env.REACT_APP_DEBUG && console.log(...formData);
    dispatch(
      Admin.actions.postNote({
        formData: formData,
        type: "Client",
        pkID: clientBooking.clientID,
      }),
    );
    setSentMsg("Message sent!");
    showMessageTimer();
  }

  function setFlag(event, id, flag) {
    if (event.target.value !== flag) {
      dispatch(
        Admin.actions.putClientFlag({
          id: id,
          flag: event.target.value,
          type: props.clienttype,
        }),
      );
    }
  }

  const showMessageTimer = () => {
    const timer = setTimeout(() => {
      setSentMsg(undefined);
      setShowBooking(false);
    }, 3000);
    return () => clearTimeout(timer);
  };

  const columns = [
    { field: "id", headerName: "ID", hide: true },
    { field: "listcolor", headerName: "List Color", hide: true },
    { field: "providertype", headerName: "Provider Type", hide: true },
    {
      field: "fullname",
      headerName: "Name",
      width: 200,
      renderCell: (params) => {
        return (
          <Grid container justifyContent="space-between">
            {params.row.csRegistrationStepCompleted !== 3 && (role !== "Admin" || rolescope === "Provisional" || rolescope === "Psychiatrist") ? (
              <Grid item onClick={() => loadIncompleteRegistration(params.row.id, params.row.csRegistrationStepCompleted)} className="cell-Link">
                <>
                  {params.row.listcolor && params.row.listcolor.length > 0 ? (
                    <>
                      <span style={{ color: params.row.listcolor }}>
                        <strong>{params.value}</strong>
                      </span>
                    </>
                  ) : (
                    <>
                      <strong>{params.value}</strong>
                    </>
                  )}
                </>
              </Grid>
            ) : (
              <Grid item onClick={() => loadClient(params.row.id)} className="cell-Link">
                <>
                  {params.row.listcolor && params.row.listcolor.length > 0 ? (
                    <>
                      <span style={{ color: params.row.listcolor }}>
                        <strong>{params.value}</strong>
                      </span>
                    </>
                  ) : (
                    <>
                      <strong>{params.value}</strong>
                    </>
                  )}
                </>
              </Grid>
            )}
          </Grid>
        );
      },
    },
    {
      field: "__actions__",
      headerName: "Actions",
      width: role === "Admin" ? 200 : 150,
      renderCell: (params) => (
        <>
          {params.row.csRegistrationStepCompleted !== 3 && (
            <Tooltip title="Complete Registration" aria-label="Complete Registration" placement="top" arrow>
              <Button
                variant="success"
                style={{
                  marginRight: 2,
                  minWidth: "70px",
                  height: "28px",
                  fontSize: "0.80rem",
                  padding: "0 6px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                size="sm"
                onClick={() => loadIncompleteRegistration(params.row.id, params.row.csRegistrationStepCompleted)}
              >
                Registration
              </Button>
            </Tooltip>
          )}
          {(params.row.csRegistrationStepCompleted === 3 || role === "Admin") && (
            <Tooltip title="Book Appointment" aria-label="Book Appointment" placement="top" arrow>
              <Button
                variant="info"
                style={{
                  marginRight: 2,
                  minWidth: "55px",
                  height: "28px",
                  fontSize: "0.80rem",
                  padding: "0 6px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                size="sm"
                onClick={() => loadAppointment(clients.find((client) => client.id === params.row.id))}
              >
                Book
              </Button>
            </Tooltip>
          )}

          {params.row.nextBookingIDPsych !== null || params.row.nextBookingIDPsychiatrist !== null ? (
            <Button
              color="secondary"
              style={{
                marginRight: 2,
                minWidth: "55px",
                height: "28px",
                fontSize: "0.80rem",
                padding: "0 6px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              size="sm"
              onClick={() => loadLink(clients.find((client) => client.id === params.row.id))}
            >
              Link
            </Button>
          ) : null}
        </>
      ),
    },
    {
      field: "__quicklinks__",
      headerName: "Quick Links",
      width: 130,
      renderCell: (params) => (
        <>
          <Button
            variant="warning"
            size="sm"
            style={{
              marginRight: 2,
              minWidth: "55px",
              height: "28px",
              fontSize: "0.80rem",
              padding: "0 6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={() =>
              loadNotes(
                clients.find((client) => client.id === params.row.id),
                "NoteOnly",
              )
            }
          >
            Notes
          </Button>
          <Button
            variant="danger"
            size="sm"
            style={{
              minWidth: "55px",
              height: "28px",
              fontSize: "0.80rem",
              padding: "0 6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={() => loadFiles(clients.find((client) => client.id === params.row.id))}
          >
            Files
          </Button>{" "}
        </>
      ),
    },
    {
      field: "statusflags",
      headerName: "Task Status",
      hide: role === "Admin" ? false : true,
      width: 150,
      renderCell: (params) => {
        return (
          <StatusFlags
            consentStatus={params.row.csConsentStatus}
            iarStatus={params.row.iarStatus}
            initialAssessmentStatus={params.row.initialAssessmentStatus}
          />
        );
      },
    },
    {
      field: "flag",
      headerName: "Follow-up",
      width: 170,
      hide: role === "Admin" ? false : true,
      cellClassName: (params) => (params.row.flag.length > 0 ? "flag-full-cell" : "flag-empty-cell"),
      renderCell: (params) => (
        <>
          <TextField
            variant="outlined"
            name={`flag`}
            defaultValue={params.row.flag}
            onBlur={(event) => setFlag(event, params.row.id, params.row.flag)}
            InputProps={{
              classes: {
                notchedOutline: classes.noBorder,
                input: params.row.flag.length > 0 ? "flag-full" : "flag-empty",
              },
            }}
            multiline
            maxRows={4}
            style={{ width: "100%" }}
            onFocus={(event) => {
              event.target.select();
            }}
          ></TextField>
        </>
      ),
    },
    {
      field: "nextBookingIDPsych",
      headerName: "Next Booking ID",
      width: 120,
      hide: true,
    },
    {
      field: "topBookingPsy",
      type: "date",
      headerName: "Booking (P)",
      width: 130,
      sortable: true,
      // valueFormatter: ({ value }) => value ? format(new Date(value), "dd-MM-yyyy HH:mm") : null,
      cellClassName: (params) =>
        params.row.nextBookingIDPsych !== null
          ? params.row.topBookingLocationPsych === "Remote"
            ? "future-booking-social"
            : "future-booking"
          : "grid-mono-font",
      renderCell: (params) => (
        <>
          {bookings && params.row.nextBookingIDPsych ? (
            <div onClick={() => loadBooking(params.row.nextBookingIDPsych)} className="cell-Link">
              {format(new Date(params.row.topBookingPsy), "dd-MM-yyyy HH:mm")}
            </div>
          ) : params.row.topBookingPsy != null ? (
            format(new Date(params.row.topBookingPsy), "dd-MM-yyyy HH:mm")
          ) : null}
        </>
      ),
    },
    {
      field: "topBookingSessionTypeDescriptionPsych",
      headerName: "Type",
      width: 120,
    },
    { field: "psychologistName", headerName: "Provider Name", width: 160 },
    {
      field: "nextBookingIDPsychiatrist",
      headerName: "Next Booking ID",
      width: 120,
      hide: true,
    },
    {
      field: "topBookingPsychiatrist",
      type: "date",
      headerName: "Booking (PSY)",
      width: 140,
      sortable: true,
      // valueFormatter: ({ value }) => value ? format(new Date(value), "dd-MM-yyyy HH:mm") : null,
      cellClassName: (params) =>
        params.row.nextBookingIDPsychiatrist !== null
          ? params.row.topBookingLocationPsychiatrist === "Remote"
            ? "future-booking-social"
            : "future-booking"
          : "grid-mono-font",
      renderCell: (params) => (
        <>
          {bookings && params.row.nextBookingIDPsychiatrist ? (
            <div onClick={() => loadBooking(params.row.nextBookingIDPsychiatrist)} className="cell-Link">
              {format(new Date(params.row.topBookingPsychiatrist), "dd-MM-yyyy HH:mm")}
            </div>
          ) : params.row.topBookingPsychiatrist != null ? (
            format(new Date(params.row.topBookingPsychiatrist), "dd-MM-yyyy HH:mm")
          ) : null}
        </>
      ),
    },
    {
      field: "topBookingSessionTypeDescriptionPsychiatrist",
      headerName: "Type",
      width: 120,
    },
    { field: "psychiatristName", headerName: "Provider Name", width: 160 },
    {
      field: "pastBookingCount",
      headerName: "Bookings",
      width: 110,
      cellClassName: "grid-mono-font",
    },
    { field: "status", headerName: "Status", width: 90, hide: true },
    // { field: 'psychologistName', headerName: 'Provider Name', width: 160 },
    {
      field: "createdby",
      headerName: "Contact",
      width: 150,
      renderCell: (params) => {
        return (
          <Grid container justifyContent="space-between">
            <Grid item onClick={() => loadOwner(params.row)} className="cell-Link">
              <strong>{params.value}</strong>
            </Grid>
          </Grid>
        );
      },
    },
  ];

  if (role === "Admin") {
    columns.push({
      field: "centreId",
      headerName: "Centre",
      width: 150,
      valueGetter: (params) => {
        const centre = csCentres.find((c) => Number(c.id) === Number(params.row.centreId));
        return centre ? centre.centerName : "";
      },
    });
  }

  if (role === "Admin" || role === "CS" || role === "CSAdmin") {
    columns.push(
      {
        field: "createdon",
        headerName: "Created On",
        type: "date",
        width: 135,
        sortable: true,
        renderCell: (params) => format(new Date(params.row.createdon), "dd-MM-yyyy HH:mm"),
        cellClassName: "grid-mono-font",
      },
      {
        field: "none1",
        headerName: "Close",
        width: 200,
        renderCell: (params) => (
          <>
            {/* <Tooltip title="Communications" aria-label="Communications" placement="top" arrow>
              <Button variant="success" style={{ marginRight:2}} size="sm" onClick={() => loadNotes(clients.find(client => client.id === params.row.id),'ALL')} >Comm</Button>
            </Tooltip> */}
            {params.row.status === "Active" && (
              <Tooltip title="Close Engagement and Send Survey" aria-label="Close" placement="top" arrow>
                <Button
                  variant="success"
                  style={{ marginRight: 2 }}
                  size="sm"
                  onClick={() => closeClient(clients.find((client) => client.id === params.row.id))}
                >
                  Close
                </Button>
              </Tooltip>
            )}
          </>
        ),
      },
    );
  }

  useEffect(() => {
    dispatch(
      Admin.actions.fetchCSClients({
        status: filters.clientsStatus,
        type: props.clienttype,
      }),
    );
  }, [dispatch, props.clienttype, filters.clientsStatus]);

  useEffect(() => {
    if (filters.clientsListLoadClientID) {
      loadClient(filters.clientsListLoadClientID);
      dispatch(
        Admin.actions.setFilters({
          filterName: "clientsListLoadClientID",
          filterValue: undefined,
        }),
      );
    }
  }, [loadClient, dispatch, filters.clientsListLoadClientID]);

  const classes = useStyles();

  const parseDate = (value) => {
    if (!value) {
      return null;
    }

    const [year, month, day] = value.substring(0, 10).split("-").map(Number);

    return new Date(year, month - 1, day);
  };

  useEffect(() => {
    const client = {
      ...initClient,
      ...thisClient,
      previousstatus: thisClient && thisClient.status,
    };
    originalClient.current = client;
    setClient(client);
  }, [thisClient, initClient]);

  useEffect(() => {
    if (!thisClient?.id) return;
    if (!filters.clientsListLoadModalID) return;

    setKey(filters.clientsListLoadModalID);

    dispatch(
      Admin.actions.setFilters({
        filterName: "clientsListLoadModalID",
        filterValue: undefined,
      }),
    );
  }, [thisClient?.id, filters.clientsListLoadModalID, dispatch]);

  const minNonWhitespace = (message) =>
    Yup.string().test("min-non-whitespace", message, (value) => {
      if (!value) return true; // let required() handle empty values
      return value.trim().length >= 3;
    });

  const requiredAtStep3 = (fieldName, schemaBuilder) =>
    Yup.lazy((value, options) => {
      const step = Number(options.parent.csRegistrationStepCompleted);

      if (step !== 3) {
        return Yup.mixed().notRequired();
      }

      const original = thisClient?.[fieldName];

      const normalise = (val) => {
        if (!val) return "";

        if (val instanceof Date) {
          const year = val.getFullYear();
          const month = String(val.getMonth() + 1).padStart(2, "0");
          const day = String(val.getDate()).padStart(2, "0");

          return `${year}-${month}-${day}`;
        }

        if (typeof val === "string") {
          // yyyy-MM-dd
          if (/^\d{4}-\d{2}-\d{2}$/.test(val)) {
            return val;
          }

          // yyyy-MM-ddTHH:mm:ss...
          if (/^\d{4}-\d{2}-\d{2}T/.test(val)) {
            return val.substring(0, 10);
          }

          // dd/MM/yyyy...
          const match = val.match(/^(\d{2})\/(\d{2})\/(\d{4})/);

          if (match) {
            const [, day, month, year] = match;
            return `${year}-${month}-${day}`;
          }
        }

        return String(val);
      };

      if (normalise(value) === normalise(original)) {
        return Yup.mixed().notRequired();
      }

      return schemaBuilder();
    });

  const validationSchema = Yup.object().shape({
    firstname: Yup.string().min(2, "Too Short").max(200, "Too Long").required("First Name is required"),
    preferredname: Yup.string().max(200, "Too Long"),
    surname: Yup.string().min(2, "Too Short").max(200, "Too Long").required("Surname is required"),
    dob: Yup.string()
      .required("Date of Birth is required")
      .test("dob", "Please enter a valid date", function (value) {
        if (!value) return false;
        const date = new Date(value);
        // Invalid date
        if (isNaN(date.getTime())) {
          return false;
        }
        const age = differenceInYears(new Date(), date);
        // Under 18
        if (age < 18) {
          return this.createError({
            message: "Consumer must be over 18 years of age",
          });
        }
        // Over 100
        if (age > 100) {
          return this.createError({
            message: "Please enter a valid date",
          });
        }
        return true;
      }),
    email: Yup.string()
      .min(2, "Too Short")
      .max(200, "Too Long")
      .email("Enter a valid email")
      .required("Email is required")
      .test("duplicate-email", "This email address is already registered", () => !emailIsDuplicate),
    mobilephone: Yup.string()
      .required("Phone number is required")
      .matches(/^\d{10}$/, "Phone number must be 10 digits and numeric"),
    fulladdress: Yup.string().min(4, "Too Short").max(80, "Too Long").required("Address is required"),
    pronouns: Yup.string().max(20, "Too Long"),
    referralPurpose: requiredAtStep3("referralPurpose", () =>
      minNonWhitespace("Must be at least 3 characters").max(4000, "Too Long").required("Purpose of Referral is required"),
    ),
    medication: requiredAtStep3("medication", () =>
      minNonWhitespace("Must be at least 3 characters").max(4000, "Too Long").required("Current medication is required"),
    ),

    hopeToGetFromTreatment: requiredAtStep3("hopeToGetFromTreatment", () =>
      minNonWhitespace("Must be at least 3 characters").max(4000, "Too Long").required("Presenting concerns & relevant background"),
    ),

    identifiedRisksAndAgreedManagement: requiredAtStep3("identifiedRisksAndAgreedManagement", () =>
      minNonWhitespace("Must be at least 3 characters").max(4000, "Too Long").required("Identified risks and agreed management strategies are required"),
    ),

    csSessionExpectation: requiredAtStep3("csSessionExpectation", () =>
      Yup.mixed()
        .test("valid-session-count", "Please enter a valid number", (value) => {
          if (value === "" || value == null) return false;

          const num = Number(value);

          return !Number.isNaN(num);
        })
        .test("whole-number", "Number of sessions must be a whole number", (value) => Number.isInteger(Number(value)))
        .test("max-sessions", "Number of sessions cannot exceed 30", (value) => Number(value) <= 30),
    ),
    estimatedEndOfCareDate: requiredAtStep3(
      "estimatedEndOfCareDate",
      () =>
        Yup.string()
          .nullable()
          .required("Estimated end of care date is required")
          .test("future-date", "Estimated end of care date must be in the future", (value) => {
            if (!value) return false;

            const today = new Date();
            const todayString = today.getFullYear() + "-" + String(today.getMonth() + 1).padStart(2, "0") + "-" + String(today.getDate()).padStart(2, "0");

            return value >= todayString;
          }),
      Yup.string().nullable().notRequired(),
    ),
    emergencycontactname1: Yup.string().min(3, "Too Short").max(100, "Too Long").required("Emergency Contact is required"),
    emergencycontactrelation1: Yup.string().min(3, "Too Short").max(50, "Too Long").required("Emergency Contact Relationship is required"),
    emergencycontactphone1: Yup.string()
      .required("Phone number is required")
      .matches(/^\d{10}$/, "Emergency Contact Phone number must be 10 digits and numeric"),
    emergencycontactname2: Yup.string().min(3, "Too Short").max(100, "Too Long").nullable(),
    emergencycontactrelation2: Yup.string().min(3, "Too Short").max(50, "Too Long").nullable(),
    emergencycontactphone2: Yup.string()
      .matches(/^\d{10}$/, "Emergency Contact Phone number must be 10 digits and numeric")
      .nullable(),
    centreClientId: Yup.string().min(3, "Case Number should be at least 3 characters").max(50, "Case Number is too Long (maximum 50 characters)"),
    csCentreID: Yup.number().required("Please select a Centre").notOneOf([0], "Please select a Centre").nullable(false),
    gpName: Yup.string().max(200, "GP Name Too Long").nullable(),
    gpClinicName: Yup.string().max(200, "GP Clinic Name Too Long").nullable(),
    gpContactNumber: Yup.string()
      .matches(/^\d{10}$/, "GP Contact Phone number must be 10 digits and numeric")
      .nullable(),
  });

  return (
    <>
      <h4>{centreName === "NotSet" ? "All Centre`s" : centreName} Clients</h4>
      <Paper>
        <Grid container style={{ padding: 10 }}>
          <Grid item style={{ paddingLeft: 2, paddingRight: 10 }}>
            <InputGroup size="sm">
              <InputGroup.Prepend>
                <InputGroup.Text>
                  <SearchIcon fontSize="small" style={{ marginLeft: -4 }} />
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control
                type="text"
                value={filters.clientsTerm}
                onChange={(event) =>
                  dispatch(
                    Admin.actions.setFilters({
                      filterName: "clientsTerm",
                      filterValue: event.target.value,
                    }),
                  )
                }
                autoComplete="OFF"
                style={{
                  maxWidth: 170,
                  height: 35,
                  backgroundColor: filters.clientsTerm.length > 0 ? "rgb(250 239 195)" : "white",
                }}
              />
              <InputGroup.Append
                onClick={() =>
                  dispatch(
                    Admin.actions.setFilters({
                      filterName: "clientsTerm",
                      filterValue: "",
                    }),
                  )
                }
              >
                <InputGroup.Text>
                  <ClearIcon
                    fontSize="small"
                    style={{
                      color: filters.clientsTerm.length > 0 ? "#222222" : "silver",
                      marginLeft: -3,
                    }}
                  />
                </InputGroup.Text>
              </InputGroup.Append>
            </InputGroup>
          </Grid>
          {/* filters.clientsPsychologist === 'All' ? 'All' :  */}
          <Grid item style={{ paddingRight: 10 }}>
            <Autocomplete
              id="searchPsychologist"
              variant="outlined"
              options={actualRegistered}
              getOptionLabel={(option) => ((filters.clientsPsychologist === "All" && !option.fullname) || !option.fullname ? "All" : option.fullname)}
              value={filters.clientsPsychologist === "All" ? null : filters.clientsPsychologist}
              onChange={(event, newValue) =>
                dispatch(
                  Admin.actions.setFilters({
                    filterName: "clientsPsychologist",
                    filterValue: newValue ? newValue : "All",
                  }),
                )
              }
              style={{
                minWidth: 200,
                fullWidth: true,
                display: "flex",
                wrap: "nowrap",
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Provider"
                  type="text"
                  variant="outlined"
                  margin="dense"
                  name="PsychologistSelector"
                  style={{
                    backgroundColor: "white",
                    margin: 0,
                    padding: 0,
                    maxWidth: 200,
                  }}
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: "new-password",
                  }}
                />
              )}
            />
          </Grid>
          <Grid item style={{ paddingLeft: 2, paddingRight: 10 }}>
            <InputGroup size="sm">
              <InputGroup.Prepend>
                <InputGroup.Text>
                  <SearchIcon fontSize="small" style={{ marginLeft: -4 }} />
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control
                placeholder="Referrer Lookup"
                type="text"
                value={filters.clientsReferrer}
                onChange={(event) =>
                  dispatch(
                    Admin.actions.setFilters({
                      filterName: "clientsReferrer",
                      filterValue: event.target.value,
                    }),
                  )
                }
                autoComplete="OFF"
                style={{
                  maxWidth: 170,
                  height: 35,
                  backgroundColor: filters.clientsTerm.length > 0 ? "rgb(250 239 195)" : "white",
                }}
              />
              <InputGroup.Append
                onClick={() =>
                  dispatch(
                    Admin.actions.setFilters({
                      filterName: "clientsReferrer",
                      filterValue: "",
                    }),
                  )
                }
              >
                <InputGroup.Text>
                  <ClearIcon
                    fontSize="small"
                    style={{
                      color: filters.clientsTerm.length > 0 ? "#222222" : "silver",
                      marginLeft: -3,
                    }}
                  />
                </InputGroup.Text>
              </InputGroup.Append>
            </InputGroup>
          </Grid>
          <Grid item style={{ paddingRight: 10 }}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="clientsStatus-label" className={classes.label}>
                Status
              </InputLabel>
              <Select
                labelId="clientsStatus-label"
                id="clientsStatus"
                margin="dense"
                style={{ minWidth: 120, backgroundColor: "#ffffff" }}
                value={filters.clientsStatus}
                onChange={(event) =>
                  dispatch(
                    Admin.actions.setFilters({
                      filterName: "clientsStatus",
                      filterValue: event.target.value,
                    }),
                  )
                }
              >
                <MenuItem value="All" disabled={role === "Admin"}>
                  All
                </MenuItem>
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Closed">Closed</MenuItem>
                <MenuItem value="Archived">Archived</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {/* <Grid item style={{ paddingRight: 10 }}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="clientsAOI-label" className={classes.label}>Areas of Interest</InputLabel>
              <Select
                labelId="clientsAOI-label"
                id="clientsAOI"
                margin="dense"
                style={{ minWidth: 120, backgroundColor: "#ffffff" }}
                value={filters.clientsAOI}
                onChange={(event) => dispatch(Admin.actions.setFilters({ filterName: 'clientsAOI', filterValue: event.target.value }))}
              >
                <MenuItem value='All'>All</MenuItem>
                {areasOfInterestReference.map(row => {
                  return <MenuItem key={`key-${row.id}`} value={row.issue}>{row.issue}</MenuItem>
                  })}
              </Select>
            </FormControl>
          </Grid> */}
          <Grid item style={{ paddingRight: 10 }}>
            <Autocomplete
              id="searchCSCentre"
              variant="outlined"
              options={csCentres}
              getOptionLabel={(option) => ((filters.csCentre === "All" && !option.centerName) || !option.centerName ? "All" : option.centerName)}
              value={filters.csCentre}
              onChange={(event, newValue) =>
                dispatch(
                  Admin.actions.setFilters({
                    filterName: "csCentre",
                    filterValue: newValue ? newValue : "All",
                  }),
                )
              }
              style={{
                minWidth: 200,
                fullWidth: true,
                display: "flex",
                wrap: "nowrap",
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Centre"
                  type="text"
                  variant="outlined"
                  margin="dense"
                  name="CSCentreSelector"
                  style={{
                    backgroundColor: "white",
                    margin: 0,
                    padding: 0,
                    maxWidth: 200,
                  }}
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: "new-password",
                  }}
                />
              )}
            />
          </Grid>

          <Grid item style={{ marginLeft: 20, marginRight: 10 }}>
            <Button variant="primary" size="sm" onClick={() => loadNewClient()}>
              Add Client
            </Button>
          </Grid>
        </Grid>
      </Paper>

      <Paper style={{ height: 700 }}>
        <DataGridPro
          rows={filteredClients}
          columns={columns}
          pagination={false}
          checkboxSelection={false}
          disableColumnMenu={true}
          rowHeight={38}
          initialState={{
            sorting: { sortModel: [{ field: "createdon", sort: "desc" }] },
          }}
          // sortModel={sortModel}
          // onSortModelChange={handleSortModelChange}
        />
      </Paper>

      {show && <div className="blur-overlay" />}
      <Modal show={show} onHide={handleClose} dialogClassName="editprofile-modal">
        <Formik
          enableReinitialize={true}
          initialValues={client}
          validationSchema={validationSchema}
          onSubmit={(values, actions) => {
            putClient(values);
            // actions.setSubmitting(false);
          }}
        >
          {(props) => {
            const { values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, setFieldTouched } = props;
            const change = (name, e) => {
              e.persist();

              if (name === "csRegistrationStepCompleted") {
                setFieldValue(name, parseInt(e.target.value, 10));
                return;
              }

              handleChange(e);
            };
            const filteredAgents = csAgents.filter((agent) => String(agent.csCentreID) === String(values.csCentreID));
            return (
              <form noValidate={true} autoComplete="off" onSubmit={handleSubmit}>
                <Modal.Header closeButton className="editprofile-modal" style={{ paddingBottom: 0 }}>
                  <Modal.Title>
                    <Grid container direction="row" spacing={0}>
                      <Grid item>
                        {values.firstname} {values.surname}
                      </Grid>
                    </Grid>
                  </Modal.Title>
                </Modal.Header>

                <Modal.Body className="editprofile-modal">
                  <Paper style={{ backgroundColor: "rgb(245,245,245)", padding: 20 }}>
                    <Tabs id="EditModal" activeKey={key} onSelect={(k) => setKey(k)} mountOnEnter={true} unmountOnExit={true}>
                      <Tab
                        eventKey="Personal"
                        title={client && client.id === 0 ? "Add New Client" : "Personal"}
                        style={{
                          backgroundColor: "rgb(245, 245, 245)",
                          padding: 6,
                        }}
                      >
                        <Row>
                          <h5 style={{ marginBottom: "25px" }}>Centralised Service Information</h5>
                        </Row>
                        <Row style={{ marginBottom: "20px" }}>
                          <Col md="3">
                            <div className="text">Estimated End of Care Date</div>
                            <div style={{ fontSize: "1.1rem" }}>{values.estimatedEndOfCare || "-"}</div>
                          </Col>
                          {/* <Col md="3">
                            <div className="text">Estimated Sessions</div>
                            <div style={{ fontSize: "1.1rem" }}>{values.estimatedSessions ?? "-"}</div>
                          </Col> */}
                          <Col md="3">
                            <div className="text">Future Bookings</div>
                            <div style={{ fontSize: "1.1rem" }}>{values.futureSessions ?? "-"}</div>
                          </Col>
                          <Col md="3">
                            <div className="text">Attended Bookings</div>
                            <div style={{ fontSize: "1.1rem" }}>{values.attendedSessions ?? "-"}</div>
                          </Col>
                          <Col md="3">
                            <div className="text">Cancelled Bookings</div>
                            <div style={{ fontSize: "1.1rem" }}>{values.cancelledSessions ?? "-"}</div>
                          </Col>
                        </Row>{" "}
                        <Row>
                          <Col md="6">
                            <Form.Group style={{ width: "100%" }}>
                              <Form.Label>Primary Centre Contact for this client*</Form.Label>
                              <Autocomplete
                                id="owner"
                                variant="outlined"
                                options={filteredAgents}
                                disabled={(role !== "Admin" && role !== "CSAdmin") || rolescope === "Psychiatrist"}
                                getOptionLabel={(option) => option.firstname + " " + option.surname}
                                value={filteredAgents.find((v) => String(v.id) === String(values.owner)) || null}
                                onChange={(e, value) => {
                                  setFieldValue("owner", value.id);
                                }}
                                style={{
                                  fullWidth: true,
                                  display: "flex",
                                  wrap: "nowrap",
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    type="text"
                                    variant="outlined"
                                    margin="dense"
                                    name="csCentreSelector"
                                    style={{
                                      backgroundColor: "white",
                                      margin: 0,
                                      padding: 0,
                                    }}
                                    inputProps={{
                                      ...params.inputProps,
                                      autoComplete: "new-password",
                                    }}
                                  />
                                )}
                              />
                            </Form.Group>
                          </Col>
                          <Col md="3">
                            <Form.Group style={{ width: "100%" }}>
                              <Form.Label>Contact Email</Form.Label>
                              <Form.Control
                                type="text"
                                name="ownerEmail"
                                value={filteredAgents.find((v) => String(v.id) === String(values.owner))?.email || ""}
                                readOnly
                                style={{ backgroundColor: "#e9ecef" }}
                              />
                            </Form.Group>
                          </Col>
                          <Col md="3">
                            <Form.Group style={{ width: "100%" }}>
                              <Form.Label>Contact Phone</Form.Label>
                              <Form.Control
                                type="text"
                                name="ownerPhone"
                                value={filteredAgents.find((v) => String(v.id) === String(values.owner))?.mobilephone || ""}
                                readOnly
                                style={{ backgroundColor: "#e9ecef" }}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="6">
                            <Form.Group style={{ width: "100%" }}>
                              <Form.Label>Centre *</Form.Label>
                              <Autocomplete
                                id="csCentre"
                                variant="outlined"
                                options={csCentres}
                                disabled={role !== "Admin" || (role === "Admin" && rolescope === "Psychiatrist")}
                                getOptionLabel={(option) => option.centerName}
                                value={csCentres.find((v) => String(v.id) === String(values.csCentreID)) || null}
                                onChange={(e, value) => {
                                  setFieldValue("csCentreID", value.id);
                                }}
                                style={{
                                  fullWidth: true,
                                  display: "flex",
                                  wrap: "nowrap",
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    type="text"
                                    variant="outlined"
                                    margin="dense"
                                    name="csCentreSelector"
                                    style={{
                                      backgroundColor: "white",
                                      margin: 0,
                                      padding: 0,
                                    }}
                                    inputProps={{
                                      ...params.inputProps,
                                      autoComplete: "new-password",
                                    }}
                                  />
                                )}
                              />
                            </Form.Group>
                          </Col>
                          <Col md="3">
                            <Form.Group style={{ width: "100%" }}>
                              <Form.Label>Centre Phone</Form.Label>
                              <Form.Control
                                type="text"
                                name="headerCSCentrePhone"
                                value={csCentres.find((v) => String(v.id) === String(values.csCentreID))?.phone || ""}
                                readOnly
                                style={{ backgroundColor: "#e9ecef" }}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <h5 style={{ marginTop: "20px", marginBottom: "25px" }}>Personal Information</h5>
                        </Row>
                        <Row>
                          <Col md="2">
                            <Form.Group>
                              <Form.Label>First Name *</Form.Label>
                              <Form.Control
                                type="text"
                                name="firstname"
                                value={values.firstname}
                                onChange={change.bind(null, "firstname")}
                                autoComplete="new-password"
                                isInvalid={touched.firstname && !!errors.firstname}
                                isValid={touched.firstname && !errors.firstname}
                              />
                              <Form.Control.Feedback type="invalid">{errors.firstname}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md="2">
                            <Form.Group>
                              <Form.Label>Surname *</Form.Label>
                              <Form.Control
                                type="text"
                                name="surname"
                                value={values.surname}
                                onChange={change.bind(null, "surname")}
                                autoComplete="new-password"
                                isInvalid={touched.surname && !!errors.surname}
                                isValid={touched.surname && !errors.surname}
                              />
                              <Form.Control.Feedback type="invalid">{errors.surname}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md="3">
                            <Form.Group>
                              <Form.Label>Preferred Name (Optional)</Form.Label>
                              <Form.Control
                                type="text"
                                name="preferredname"
                                value={values.preferredname}
                                onChange={change.bind(null, "preferredname")}
                                autoComplete="new-password"
                                isInvalid={touched.preferredname && !!errors.preferredname}
                                isValid={touched.preferredname && !errors.preferredname}
                              />
                              <Form.Control.Feedback type="invalid">{errors.preferredname}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md="3">
                            <Form.Group>
                              <Form.Label>Gender *</Form.Label>
                              <Form.Control as="select" name="gender" value={values.gender} onChange={change.bind(null, "gender")}>
                                <option value="Prefer not to say">Prefer not to say</option>
                                <option value="Female">Female</option>
                                <option value="Male">Male</option>
                                <option value="Other">Other</option>
                              </Form.Control>
                            </Form.Group>
                          </Col>
                          <Col md="2">
                            <Form.Group>
                              <Form.Label>Pronouns (Optional)</Form.Label>
                              <Form.Control
                                type="text"
                                name="pronouns"
                                value={values.pronouns}
                                onChange={change.bind(null, "pronouns")}
                                autoComplete="new-password"
                                isInvalid={touched.pronouns && !!errors.pronouns}
                                isValid={touched.pronouns && !errors.pronouns}
                              />
                              <Form.Control.Feedback type="invalid">{errors.pronouns}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="3">
                            <Form.Group>
                              <Form.Label>Date of Birth *</Form.Label>
                              <Form.Control
                                type="date"
                                name="dob"
                                value={values.dob}
                                onChange={change.bind(null, "dob")}
                                isInvalid={touched.dob && !!errors.dob}
                                isValid={touched.dob && !errors.dob}
                                autoComplete="new-password"
                              />
                              <Form.Control.Feedback type="invalid">{errors.dob}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md="6">
                            <Form.Group>
                              <Form.Label>Email * </Form.Label>
                              <Form.Control
                                type="text"
                                name="email"
                                value={values.email}
                                onChange={(e) => {
                                  setEmailIsDuplicate(false);
                                  change("email", e);
                                }}
                                onBlur={(e) => {
                                  handleBlur(e);
                                  if (e.currentTarget.value && e.currentTarget.value.length > 0) {
                                    dispatch(Registration.actions.emailDuplicate(e.currentTarget.value));
                                  }
                                }}
                                isInvalid={touched.email && !!errors.email}
                                isValid={touched.email && !errors.email}
                                autoComplete="new-password"
                              />
                              <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>{" "}
                            </Form.Group>
                          </Col>
                          <Col md="3">
                            <Form.Group>
                              <Form.Label>Phone Number *</Form.Label>
                              <Form.Control
                                type="text"
                                name="mobilephone"
                                value={values.mobilephone}
                                onChange={change.bind(null, "mobilephone")}
                                isInvalid={touched.mobilephone && !!errors.mobilephone}
                                isValid={touched.mobilephone && !errors.mobilephone}
                                autoComplete="new-password"
                              />
                              <Form.Control.Feedback type="invalid">{errors.mobilephone}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="9">
                            <Form.Group style={{ width: "100%" }}>
                              <Form.Label>Home Address (start typing to search) *</Form.Label>
                              <PlacesAutoComplete
                                currentID={values.id}
                                currentfulladdress={values.fulladdress}
                                setcurrentfulladdress={(value) => setFieldValue("fulladdress", value)}
                                setcurrentLatitude={(value) => setFieldValue("latitude", value)}
                                setcurrentLongitude={(value) => setFieldValue("longitude", value)}
                                setcurrentPostCode={(value) => setFieldValue("postcode", value)}
                                isInvalid={touched.fulladdress && !!errors.fulladdress}
                                isValid={touched.fulladdress && !errors.fulladdress}
                              />
                              {touched.fulladdress && !!errors.fulladdress ? <p className="error-help">{errors.fulladdress}</p> : ""}
                            </Form.Group>
                          </Col>
                          <Col md="3">
                            <Form.Group>
                              <Form.Label>Reporting Post Code</Form.Label>
                              <Form.Control
                                type="text"
                                name="postcode"
                                value={values.postcode}
                                onChange={change.bind(null, "postcode")}
                                autoComplete="new-password"
                                isInvalid={touched.postcode && !!errors.postcode}
                                isValid={touched.postcode && !errors.postcode}
                              />
                              <Form.Control.Feedback type="invalid">{errors.postcode}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          {client && client.id !== 0 ? (
                            <Col md="6">
                              <Form.Group>
                                <Form.Label>Selected Provider </Form.Label>
                                <Autocomplete
                                  multiple
                                  id="currentProvider"
                                  disabled={rolescope === "Psychiatrist" ? true : false}
                                  options={registeredPsychologists} // your existing providerOptions array
                                  getOptionLabel={(option) => `${option.fullname} (${option.providertype})`}
                                  value={
                                    // Map Formik value (IDs) to option objects for display
                                    registeredPsychologists.filter((option) =>
                                      Array.isArray(values.currentprovider)
                                        ? values.currentprovider.map(Number).includes(Number(option.id))
                                        : typeof values.currentprovider === "string"
                                          ? values.currentprovider
                                              .split(",")
                                              .map((v) => Number(v.trim()))
                                              .includes(Number(option.id))
                                          : false,
                                    )
                                  }
                                  getOptionSelected={(option, value) => Number(option.id) === Number(value.id)}
                                  onChange={(event, newValues) => {
                                    // Update Formik values directly
                                    setFieldValue(
                                      "currentprovider",
                                      newValues.map((v) => Number(v.id)), // always store numeric IDs
                                    );
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Current Providers"
                                      variant="outlined"
                                      margin="dense"
                                      style={{
                                        backgroundColor: "white",
                                        maxWidth: 300,
                                      }}
                                    />
                                  )}
                                />
                              </Form.Group>
                            </Col>
                          ) : null}
                          <Col md="6">
                            <Form.Group style={{ width: "100%" }}>
                              <Form.Label>TimeZone *</Form.Label>
                              <Autocomplete
                                id="TimeZone"
                                variant="outlined"
                                options={timeZone}
                                getOptionLabel={(option) => option.name}
                                value={
                                  timeZone.find((v) => String(v.systemName) === String(values.timezone)) ||
                                  timeZone.find((v) => String(v.systemName) === String(browserTZMS && browserTZMS.systemName)) ||
                                  null
                                }
                                onChange={(e, value) => {
                                  setFieldValue("timezone", value.systemName);
                                }}
                                style={{
                                  fullWidth: true,
                                  display: "flex",
                                  wrap: "nowrap",
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    type="text"
                                    variant="outlined"
                                    margin="dense"
                                    name="TimeZoneSelector"
                                    style={{
                                      backgroundColor: "white",
                                      margin: 0,
                                      padding: 0,
                                    }}
                                    inputProps={{
                                      ...params.inputProps,
                                      autoComplete: "new-password",
                                    }}
                                  />
                                )}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="4">
                            <Form.Group>
                              <Form.Label>Case Number*</Form.Label>
                              <Form.Control
                                type="text"
                                name="centreClientId"
                                value={values.centreClientId || ""}
                                onChange={change.bind(null, "centreClientId")}
                                isInvalid={touched.centreClientId && !!errors.centreClientId}
                                isValid={touched.centreClientId && !errors.centreClientId}
                                autoComplete="new-password"
                              />
                              <Form.Control.Feedback type="invalid">{errors.centreClientId}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="4">
                            <Form.Group>
                              <Form.Label>Primary Emergency Contact*</Form.Label>
                              <Form.Control
                                type="text"
                                name="emergencycontactname1"
                                value={values.emergencycontactname1 || ""}
                                onChange={change.bind(null, "emergencycontactname1")}
                                isInvalid={touched.emergencycontactname1 && !!errors.emergencycontactname1}
                                isValid={touched.emergencycontactname1 && !errors.emergencycontactname1}
                                autoComplete="new-password"
                              />
                              <Form.Control.Feedback type="invalid">{errors.emergencycontactname1}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md="4">
                            <Form.Group>
                              <Form.Label>Relationship*</Form.Label>
                              <Form.Control
                                type="text"
                                name="emergencycontactrelation1"
                                value={values.emergencycontactrelation1 || ""}
                                onChange={change.bind(null, "emergencycontactrelation1")}
                                isInvalid={touched.emergencycontactrelation1 && !!errors.emergencycontactrelation1}
                                isValid={touched.emergencycontactrelation1 && !errors.emergencycontactrelation1}
                                autoComplete="new-password"
                              />
                              <Form.Control.Feedback type="invalid">{errors.emergencycontactrelation1}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md="4">
                            <Form.Group>
                              <Form.Label>Phone *</Form.Label>
                              <Form.Control
                                type="text"
                                name="emergencycontactphone1"
                                value={values.emergencycontactphone1 || ""}
                                onChange={change.bind(null, "emergencycontactphone1")}
                                isInvalid={touched.emergencycontactphone1 && !!errors.emergencycontactphone1}
                                isValid={touched.emergencycontactphone1 && !errors.emergencycontactphone1}
                                autoComplete="new-password"
                              />
                              <Form.Control.Feedback type="invalid">{errors.emergencycontactphone1}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="4">
                            <Form.Group>
                              <Form.Label>Secondary Emergency Contact</Form.Label>
                              <Form.Control
                                type="text"
                                name="emergencycontactname2"
                                value={values.emergencycontactname2 || ""}
                                onChange={change.bind(null, "emergencycontactname2")}
                                isInvalid={touched.emergencycontactname2 && !!errors.emergencycontactname2}
                                isValid={touched.emergencycontactname2 && !errors.emergencycontactname2}
                                autoComplete="new-password"
                              />
                              <Form.Control.Feedback type="invalid">{errors.emergencycontactname2}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md="4">
                            <Form.Group>
                              <Form.Label>Relationship</Form.Label>
                              <Form.Control
                                type="text"
                                name="emergencycontactrelation2"
                                value={values.emergencycontactrelation2 || ""}
                                onChange={change.bind(null, "emergencycontactrelation2")}
                                isInvalid={touched.emergencycontactrelation2 && !!errors.emergencycontactrelation2}
                                isValid={touched.emergencycontactrelation2 && !errors.emergencycontactrelation2}
                                autoComplete="new-password"
                              />
                              <Form.Control.Feedback type="invalid">{errors.emergencycontactrelation2}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md="4">
                            <Form.Group>
                              <Form.Label>Phone</Form.Label>
                              <Form.Control
                                type="text"
                                name="emergencycontactphone2"
                                value={values.emergencycontactphone2 || ""}
                                onChange={change.bind(null, "emergencycontactphone2")}
                                isInvalid={touched.emergencycontactphone2 && !!errors.emergencycontactphone2}
                                isValid={touched.emergencycontactphone2 && !errors.emergencycontactphone2}
                                autoComplete="new-password"
                              />
                              <Form.Control.Feedback type="invalid">{errors.emergencycontactphone2}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="3">
                            <Form.Group>
                              <Form.Label>Appointment Type *</Form.Label>
                              <Form.Control as="select" name="appointmenttype" value={values.appointmenttype} onChange={change.bind(null, "appointmenttype")}>
                                <option key="Video" value="0">
                                  Video Call
                                </option>
                                <option key="Phone" value="1">
                                  Phone Call
                                </option>
                              </Form.Control>
                            </Form.Group>
                          </Col>
                          <Col md="3">
                            <Form.Group>
                              <Form.Label>Notification Preference *</Form.Label>
                              <Form.Control
                                as="select"
                                name="notificationPreference"
                                value={values.notificationPreference}
                                onChange={change.bind(null, "notificationPreference")}
                              >
                                <option value="BOTH">SMS and Email</option>
                                <option value="EMAIL">Email</option>
                                <option value="SMS">SMS</option>
                                <option value="NONE">None</option>
                              </Form.Control>
                            </Form.Group>
                          </Col>
                          <Col md="3">
                            <Form.Group>
                              <Form.Label>Test Client*</Form.Label>
                              <Form.Control
                                as="select"
                                name="testClient"
                                value={values.testClient}
                                onChange={change.bind(null, "testClient")}
                                disabled={role !== "Admin" || (role === "Admin" && rolescope === "Psychiatrist")}
                              >
                                <option value="0">No</option>
                                <option value="1">Yes</option>
                              </Form.Control>
                            </Form.Group>
                          </Col>
                          <Col md="3">
                            <Form.Group>
                              <Form.Label>List Colour</Form.Label>
                              <Form.Control as="select" name="listcolor" value={values.listcolor} onChange={change.bind(null, "listcolor")}>
                                <option value="Black">Black</option>
                                <option value="Green">Green</option>
                                <option value="Blue">Blue</option>
                                <option value="Brown">Brown</option>
                                <option value="Red">Red</option>
                                {/* <option value="Yellow">Yellow</option> - Not Readable */}
                                <option value="Orange">Orange</option>
                                <option value="Purple">Purple</option>
                                <option value="Pink">Pink</option>
                                <option value="Grey">Grey</option>
                              </Form.Control>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="3">
                            <Form.Group>
                              <Form.Label>Status *</Form.Label>
                              <Form.Control as="select" name="status" value={values.status} onChange={change.bind(null, "status")}>
                                <option value="Active">Active</option>
                                <option value="Closed">Closed</option>
                                <option value="Archived">Archived</option>
                              </Form.Control>
                            </Form.Group>
                          </Col>
                          {role === "Admin" && rolescope !== "Psychiatrist" ? (
                            <>
                              <Col md="3">
                                <Form.Group>
                                  <Form.Label>Registration Status</Form.Label>
                                  <Form.Control
                                    as="select"
                                    name="csRegistrationStepCompleted"
                                    value={values.csRegistrationStepCompleted}
                                    onChange={change.bind(null, "csRegistrationStepCompleted")}
                                  >
                                    <option value={1}>Consumer Information</option>
                                    <option value={2}>Referral Information</option>
                                    <option value={3}>Registration Complete</option>
                                  </Form.Control>
                                </Form.Group>
                              </Col>
                            </>
                          ) : null}
                        </Row>
                        <Row>
                          <Col md="4">
                            <Form.Group>
                              <Form.Label>Translator Required *</Form.Label>
                              <Form.Control as="select" name="translator" value={values.translator} onChange={change.bind(null, "translator")}>
                                <option value="No">No</option>
                                <option value="Yes">Yes</option>
                              </Form.Control>
                            </Form.Group>
                          </Col>
                          {values.translator === "Yes" ? (
                            <Col md="6">
                              <Form.Group>
                                <Form.Label>Language</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="translatorlanguage"
                                  value={values.translatorlanguage}
                                  onChange={change.bind(null, "translatorlanguage")}
                                  autoComplete="new-password"
                                  isInvalid={touched.translatorlanguage && !!errors.translatorlanguage}
                                />
                                <Form.Control.Feedback type="invalid">{errors.translatorlanguage}</Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                          ) : null}
                        </Row>
                        {/* is a support person required if so who */}
                        <Row>
                          <Col md="4">
                            <Form.Group>
                              <Form.Label>Support Person Required *</Form.Label>
                              <Form.Control as="select" name="supportPerson" value={values.supportPerson} onChange={change.bind(null, "supportPerson")}>
                                <option value="No">No</option>
                                <option value="Yes">Yes</option>
                              </Form.Control>
                            </Form.Group>
                          </Col>
                          {values.supportPerson === "Yes" ? (
                            <Col md="6">
                              <Form.Group>
                                <Form.Label>Type of support person</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="supportPersonDetail"
                                  value={values.supportPersonDetail}
                                  onChange={change.bind(null, "supportPersonDetail")}
                                  autoComplete="new-password"
                                  isInvalid={touched.supportPersonDetail && !!errors.supportPersonDetail}
                                />
                                <Form.Control.Feedback type="invalid">{errors.supportPersonDetail}</Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                          ) : null}
                        </Row>
                        <hr />
                        {client && client.id === 0 ? (
                          <>
                            <hr />
                            <Row>
                              <Col md="4">
                                <h4>Client's GP</h4>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="4">
                                <Form.Group>
                                  <Form.Label>GP Name</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="gpName"
                                    value={values.gpName}
                                    onChange={change.bind(null, "gpName")}
                                    autoComplete="new-password"
                                    isInvalid={touched.gpName && !!errors.gpName}
                                  />
                                  <Form.Control.Feedback type="invalid">{errors.gpName}</Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                              <Col md="4">
                                <Form.Group>
                                  <Form.Label>GP Clinic Name</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="gpClinicName"
                                    value={values.gpClinicName}
                                    onChange={change.bind(null, "gpClinicName")}
                                    autoComplete="new-password"
                                    isInvalid={touched.gpClinicName && !!errors.gpClinicName}
                                  />
                                  <Form.Control.Feedback type="invalid">{errors.gpClinicName}</Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                              <Col md="4">
                                <Form.Group>
                                  <Form.Label>GP Phone Number</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="gpContactNumber"
                                    value={values.gpContactNumber}
                                    onChange={change.bind(null, "gpContactNumber")}
                                    autoComplete="new-password"
                                    isInvalid={touched.gpContactNumber && !!errors.gpContactNumber}
                                  />
                                  <Form.Control.Feedback type="invalid">{errors.gpContactNumber}</Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                          </>
                        ) : null}
                        {client && client.id === 0 ? (
                          <>
                            <hr />
                            <Row>
                              <Col md="4">
                                <h4>Demographics </h4>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>Aboriginal and Torres Strait Islander Status *</Form.Label>
                                  <Form.Control as="select" name="aboriginal" value={values.aboriginal} onChange={change.bind(null, "aboriginal")}>
                                    <option value="4">Neither Aboriginal or Torres Strait Islander origin</option>
                                    <option value="1">Aboriginal but not Torres Strait Islander origin</option>
                                    <option value="2">Torres Strait Islander but not Aboriginal origin</option>
                                    <option value="3">Both Aboriginal and Torres Strait Islander origin</option>
                                    <option value="9">Not stated/inadequately described</option>
                                  </Form.Control>
                                </Form.Group>
                              </Col>
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>Homelessness Status *</Form.Label>
                                  <Form.Control as="select" name="homelessness" value={values.homelessness} onChange={change.bind(null, "homelessness")}>
                                    <option value="3">Not homeless</option>
                                    <option value="1">Sleeping rough or in nonconventional accommodation</option>
                                    <option value="2">Short-term or emergency accommodation</option>
                                    <option value="9">Not stated/inadequately described</option>
                                  </Form.Control>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>Labour Force Status *</Form.Label>
                                  <Form.Control as="select" name="labour" value={values.labour} onChange={change.bind(null, "labour")}>
                                    <option value="1">Employed</option>
                                    <option value="2">Unemployed</option>
                                    <option value="3">Not in the labour force</option>
                                    <option value="9">Not stated/inadequately described</option>
                                  </Form.Control>
                                </Form.Group>
                              </Col>
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>LGBTIQA+ Status *</Form.Label>
                                  <Form.Control as="select" name="lgbtiqa" value={values.lgbtiqa} onChange={change.bind(null, "lgbtiqa")}>
                                    <option value="1">Straight / Heterosexual</option>
                                    <option value="2">Gay or lesbian</option>
                                    <option value="3">Bisexual</option>
                                    <option value="4">Different term</option>
                                    <option value="5">Don't know</option>
                                    <option value="6">Prefer not to answer</option>
                                  </Form.Control>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>Highest Education Level Achieved *</Form.Label>
                                  <Form.Control as="select" name="education" value={values.education} onChange={change.bind(null, "education")}>
                                    <option value="6">Secondary education</option>
                                    <option value="7">Primary education</option>
                                    <option value="1">Postgraduate degree level</option>
                                    <option value="2">Graduate diploma and Graduate Certificate level</option>
                                    <option value="3">Bachelor degree level</option>
                                    <option value="4">Advanced diploma and diploma level</option>
                                    <option value="5">Certificate level</option>
                                    <option value="8">Pre-primary education</option>
                                    <option value="9">Other education</option>
                                  </Form.Control>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>Disability Status *</Form.Label>
                                  <Form.Control
                                    as="select"
                                    name="disabilityStatus"
                                    value={values.disabilityStatus}
                                    onChange={change.bind(null, "disabilityStatus")}
                                  >
                                    <option value="No">No</option>
                                    <option value="Yes">Yes</option>
                                  </Form.Control>
                                </Form.Group>
                              </Col>
                              {values.disabilityStatus === "Yes" ? (
                                <Col md="6">
                                  <Form.Group>
                                    <Form.Label>Disability Type</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="disabilityType"
                                      value={values.disabilityType}
                                      onChange={change.bind(null, "disabilityType")}
                                      autoComplete="new-password"
                                      isInvalid={touched.disabilityType && !!errors.disabilityType}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.disabilityType}</Form.Control.Feedback>
                                  </Form.Group>
                                </Col>
                              ) : null}
                            </Row>
                            <Row>
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>Country of Birth *</Form.Label>
                                  <Autocomplete
                                    id="countryofbirth"
                                    variant="outlined"
                                    options={countries}
                                    getOptionLabel={(option) => option.countryName}
                                    value={countries.find((v) => String(v.countryCode) === String(values.birthCountry))}
                                    onChange={(e, value) => {
                                      setFieldValue("birthCountry", value.countryCode);
                                    }}
                                    style={{
                                      fullWidth: true,
                                      display: "flex",
                                      wrap: "nowrap",
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        type="text"
                                        variant="outlined"
                                        margin="dense"
                                        name="CountryOfBirthSelector"
                                        style={{
                                          backgroundColor: "white",
                                          margin: 0,
                                          padding: 0,
                                        }}
                                        inputProps={{
                                          ...params.inputProps,
                                          autoComplete: "new-password",
                                        }}
                                      />
                                    )}
                                    autoComplete="new-password"
                                  />
                                </Form.Group>
                              </Col>
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>Main Language Spoken at Home *</Form.Label>
                                  <Autocomplete
                                    id="languageathome"
                                    variant="outlined"
                                    options={languages}
                                    getOptionLabel={(option) => option.languageName}
                                    value={languages.find((v) => String(v.languageCode) === String(values.language))}
                                    onChange={(e, value) => {
                                      setFieldValue("language", value.languageCode);
                                    }}
                                    style={{
                                      fullWidth: true,
                                      display: "flex",
                                      wrap: "nowrap",
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        type="text"
                                        variant="outlined"
                                        margin="dense"
                                        name="LanguageAtHomeSelector"
                                        style={{
                                          backgroundColor: "white",
                                          margin: 0,
                                          padding: 0,
                                        }}
                                        inputProps={{
                                          ...params.inputProps,
                                          autoComplete: "new-password",
                                        }}
                                      />
                                    )}
                                    autoComplete="new-password"
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>English Proficiency *</Form.Label>
                                  <Form.Control as="select" name="proficiency" value={values.proficiency} onChange={change.bind(null, "proficiency")}>
                                    <option value="0">Not applicable (persons under 5 years of age or who speak only English)</option>
                                    <option value="1">Very well</option>
                                    <option value="2">Well</option>
                                    <option value="3">Not well</option>
                                    <option value="4">Not at all</option>
                                    <option value="9">Not stated/inadequately described</option>
                                  </Form.Control>
                                </Form.Group>
                              </Col>
                            </Row>
                          </>
                        ) : null}
                        {(client && client.id === 0) || resetConsent ? (
                          <>
                            <hr />
                            <Row>
                              <Col md="6">
                                <Form.Group className="mb-0" style={{ width: "100%" }}>
                                  <Form.Label>Client Consent *</Form.Label>
                                  <Form.Control
                                    as="select"
                                    name="csConsent"
                                    value={values.csConsent}
                                    onChange={(e) => {
                                      const selectedValue = e.target.value;
                                      setFieldValue("csConsent", selectedValue);
                                      if (selectedValue) {
                                        handleConsentAction(selectedValue);
                                      }
                                    }}
                                  >
                                    <option value="">Select Consent Method</option>
                                    <option value="FormNow">Display on screen for electronic signing (inc. verbal consent)</option>
                                    <option value="Download">Download for printing, signing and upload</option>
                                    <option value="FormOnSave">Email to Client after registration</option>
                                  </Form.Control>
                                </Form.Group>
                              </Col>
                              {values.csConsent === "FormOnSave" ? (
                                <Col md="6">
                                  <Form.Group className="mb-0" style={{ width: "100%", marginTop: "25px" }}>
                                    <Form.Label
                                      style={{
                                        fontStyle: "italic",
                                        color: "blue",
                                      }}
                                    >
                                      For clients registering remotely only. By sending this form you are confirming that the client has provided verbal consent
                                      to for their details to be entered into the system. Consent form must be completed before an appointment is booked.
                                    </Form.Label>
                                  </Form.Group>
                                </Col>
                              ) : null}
                            </Row>
                          </>
                        ) : (
                          <>
                            <hr />
                            <Form.Group>
                              <Form.Label>Consent Status</Form.Label>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "2rem",
                                }}
                              >
                                <span
                                  className="text-muted"
                                  style={{
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {values.csConsentStatus || "Not Set"}
                                </span>
                                <Button variant="primary" style={{ whiteSpace: "nowrap" }} onClick={() => setResetConsent(true)}>
                                  Reset Consent Status
                                </Button>
                              </div>
                            </Form.Group>
                          </>
                        )}
                      </Tab>
                      <Tab
                        eventKey="Referral"
                        title="Referral"
                        style={{
                          backgroundColor: "rgb(245, 245, 245)",
                          padding: 6,
                        }}
                      >
                        {client && client.id !== 0 ? (
                          <>
                            <h5>Referral Information</h5>
                            <Row>
                              <Col md="12">
                                <Form.Group>
                                  <Form.Label>Purpose of referral *</Form.Label>
                                  <Form.Control
                                    as="textarea"
                                    rows={4}
                                    type="text"
                                    name="referralPurpose"
                                    value={values.referralPurpose}
                                    onChange={change.bind(null, "referralPurpose")}
                                    isInvalid={touched.referralPurpose && !!errors.referralPurpose}
                                    isValid={touched.referralPurpose && !errors.referralPurpose}
                                    autoComplete="new-password"
                                  />
                                  <Form.Control.Feedback type="invalid">{errors.referralPurpose}</Form.Control.Feedback>
                                  <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                                    What would the consumer like to achieve through this referral?
                                  </Form.Label>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="12">
                                <Form.Group>
                                  <Form.Label>Presenting concerns & relevant background*</Form.Label>
                                  <Form.Control
                                    as="textarea"
                                    rows={4}
                                    type="text"
                                    name="hopeToGetFromTreatment"
                                    value={values.hopeToGetFromTreatment}
                                    onChange={change.bind(null, "hopeToGetFromTreatment")}
                                    isInvalid={touched.hopeToGetFromTreatment && !!errors.hopeToGetFromTreatment}
                                    isValid={touched.hopeToGetFromTreatment && !errors.hopeToGetFromTreatment}
                                    autoComplete="new-password"
                                  />
                                  <Form.Control.Feedback type="invalid">{errors.hopeToGetFromTreatment}</Form.Control.Feedback>
                                  <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                                    Please provide details that support collaborative care, such as frequency of case conferences, support needs, etc. If
                                    referral information is described in the IAR please refer to it.
                                  </Form.Label>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="12">
                                <Form.Group>
                                  <Form.Label>Current Medication</Form.Label>
                                  <Form.Control
                                    as="textarea"
                                    rows={4}
                                    type="text"
                                    name="medication"
                                    value={values.medication}
                                    onChange={change.bind(null, "medication")}
                                    isInvalid={touched.medication && !!errors.medication}
                                    isValid={touched.medication && !errors.medication}
                                    autoComplete="new-password"
                                  />
                                  <Form.Control.Feedback type="invalid">{errors.medication}</Form.Control.Feedback>
                                  <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                                    Please provide details of client's current medication. If current medication is described in IAR please refer to it.
                                  </Form.Label>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="12">
                                <Form.Group>
                                  <Form.Label>Identified risks and agreed management strategies*</Form.Label>
                                  <Form.Control
                                    as="textarea"
                                    rows={4}
                                    type="text"
                                    name="identifiedRisksAndAgreedManagement"
                                    value={values.identifiedRisksAndAgreedManagement}
                                    onChange={change.bind(null, "identifiedRisksAndAgreedManagement")}
                                    isInvalid={touched.identifiedRisksAndAgreedManagement && !!errors.identifiedRisksAndAgreedManagement}
                                    isValid={touched.identifiedRisksAndAgreedManagement && !errors.identifiedRisksAndAgreedManagement}
                                    autoComplete="new-password"
                                  />
                                  <Form.Control.Feedback type="invalid">{errors.identifiedRisksAndAgreedManagement}</Form.Control.Feedback>
                                  <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                                    Please provide details about any identified risks and agreed management plans. You can find additional information and a
                                    template in the Centralised Service Clinical Risk Assessment and Management Policy in the Resources tab.
                                  </Form.Label>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="6">
                                <Form.Group style={{ width: "100%" }}>
                                  <Form.Label>Centre anticipated end of care*</Form.Label>

                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "flex-end",
                                    }}
                                  >
                                    <Form.Control
                                      type="date"
                                      id="estimatedEndOfCareDate"
                                      name="estimatedEndOfCareDate"
                                      value={values.estimatedEndOfCareDate || ""}
                                      onChange={(e) => setFieldValue("estimatedEndOfCareDate", e.target.value)}
                                      onBlur={() => setFieldTouched("estimatedEndOfCareDate", true)}
                                      isInvalid={touched.estimatedEndOfCareDate && Boolean(errors.estimatedEndOfCareDate)}
                                      style={{
                                        height: 38,
                                        fontSize: 14,
                                        backgroundColor: "#fff",
                                      }}
                                    />
                                  </div>

                                  {touched.estimatedEndOfCareDate && errors.estimatedEndOfCareDate && (
                                    <Form.Control.Feedback type="invalid">{errors.estimatedEndOfCareDate}</Form.Control.Feedback>
                                  )}

                                  <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                                    Please estimate date of anticipated end of care. End of care date can be updated during consumers care.
                                  </Form.Label>
                                </Form.Group>
                              </Col>
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>Estimated total number of sessions</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="csSessionExpectation"
                                    value={values.csSessionExpectation}
                                    autoComplete="new-password"
                                    onChange={(e) => {
                                      change("csSessionExpectation", e);
                                    }}
                                    isInvalid={touched.csSessionExpectation && !!errors.csSessionExpectation}
                                  />
                                  <Form.Control.Feedback type="invalid">{errors.csSessionExpectation}</Form.Control.Feedback>
                                  <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                                    Please estimate the total number of sessions. Number of sessions can be updated during consumers care.
                                  </Form.Label>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="12">
                                <Form.Group>
                                  <Form.Label>MMHC contact and process expectations*</Form.Label>
                                  <Form.Control
                                    as="textarea"
                                    rows={4}
                                    type="text"
                                    name="referralInformation"
                                    value={values.referralInformation}
                                    onChange={change.bind(null, "referralInformation")}
                                    isInvalid={touched.referralInformation && !!errors.referralInformation}
                                    isValid={touched.referralInformation && !errors.referralInformation}
                                    autoComplete="new-password"
                                  />
                                  <Form.Control.Feedback type="invalid">{errors.referralInformation}</Form.Control.Feedback>
                                  <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                                    Please provide details of the contact and process expectations. If current process expectations are described in the IAR,
                                    please refer to it.
                                  </Form.Label>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="12">
                                <Form.Group>
                                  <Form.Label>Special Circumstances</Form.Label>
                                  <Form.Control
                                    as="textarea"
                                    rows={4}
                                    type="text"
                                    name="specialCircumstances"
                                    value={values.specialCircumstances}
                                    onChange={change.bind(null, "specialCircumstances")}
                                    isInvalid={touched.specialCircumstances && !!errors.specialCircumstances}
                                    isValid={touched.specialCircumstances && !errors.specialCircumstances}
                                    autoComplete="new-password"
                                  />
                                  <Form.Control.Feedback type="invalid">{errors.specialCircumstances}</Form.Control.Feedback>
                                  <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                                    Please provide details of any special circumstances. If relevant details are described in the IAR, please refer to it.
                                  </Form.Label>
                                </Form.Group>
                              </Col>
                            </Row>
                            <h5>Assessments</h5>
                            <Row>
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>Initial Assessment Status</Form.Label>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "2rem",
                                    }}
                                  >
                                    <span
                                      className="text-muted"
                                      style={{
                                        fontSize: "1rem",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {values.initalAssessmentOutcome || "Not Set"}
                                    </span>
                                  </div>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>IAR Upload Status</Form.Label>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "2rem",
                                    }}
                                  >
                                    <span
                                      className="text-muted"
                                      style={{
                                        fontSize: "1rem",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {values.recentIARFileURL || "No Upload"}
                                    </span>
                                  </div>
                                </Form.Group>
                              </Col>
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>Upload IAR: *</Form.Label>
                                  <Form.Control
                                    type="file"
                                    name="recentIARFile"
                                    onChange={(event) => setFieldValue("recentIARFile", event.currentTarget.files[0])}
                                    className="form-control"
                                    style={{ paddingTop: 6, paddingLeft: 6 }}
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                          </>
                        ) : null}
                      </Tab>
                      <Tab
                        eventKey="ClientGP"
                        title="GP"
                        style={{
                          backgroundColor: "rgb(245, 245, 245)",
                          padding: 6,
                        }}
                      >
                        {client && client.id !== 0 ? (
                          <>
                            <Row>
                              <Col md="4">
                                <Form.Group>
                                  <Form.Label>GP Name</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="gpName"
                                    value={values.gpName}
                                    onChange={change.bind(null, "gpName")}
                                    autoComplete="new-password"
                                    isInvalid={touched.gpName && !!errors.gpName}
                                  />
                                  <Form.Control.Feedback type="invalid">{errors.gpName}</Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                              <Col md="4">
                                <Form.Group>
                                  <Form.Label>GP Clinic Name</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="gpClinicName"
                                    value={values.gpClinicName}
                                    onChange={change.bind(null, "gpClinicName")}
                                    autoComplete="new-password"
                                    isInvalid={touched.gpClinicName && !!errors.gpClinicName}
                                  />
                                  <Form.Control.Feedback type="invalid">{errors.gpClinicName}</Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                              <Col md="4">
                                <Form.Group>
                                  <Form.Label>GP Phone Number</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="gpContactNumber"
                                    value={values.gpContactNumber}
                                    onChange={change.bind(null, "gpContactNumber")}
                                    autoComplete="new-password"
                                    isInvalid={touched.gpContactNumber && !!errors.gpContactNumber}
                                  />
                                  <Form.Control.Feedback type="invalid">{errors.gpContactNumber}</Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                          </>
                        ) : null}
                      </Tab>
                      <Tab
                        eventKey="Demographics"
                        title="Demographics"
                        style={{
                          backgroundColor: "rgb(245, 245, 245)",
                          padding: 6,
                        }}
                      >
                        {client && client.id !== 0 ? (
                          <>
                            <Row>
                              <Col md="4">
                                <h4>Demographics </h4>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>Aboriginal and Torres Strait Islander Status *</Form.Label>
                                  <Form.Control as="select" name="aboriginal" value={values.aboriginal} onChange={change.bind(null, "aboriginal")}>
                                    <option value="4">Neither Aboriginal or Torres Strait Islander origin</option>
                                    <option value="1">Aboriginal but not Torres Strait Islander origin</option>
                                    <option value="2">Torres Strait Islander but not Aboriginal origin</option>
                                    <option value="3">Both Aboriginal and Torres Strait Islander origin</option>
                                    <option value="9">Not stated/inadequately described</option>
                                  </Form.Control>
                                </Form.Group>
                              </Col>
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>Homelessness Status *</Form.Label>
                                  <Form.Control as="select" name="homelessness" value={values.homelessness} onChange={change.bind(null, "homelessness")}>
                                    <option value="3">Not homeless</option>
                                    <option value="1">Sleeping rough or in nonconventional accommodation</option>
                                    <option value="2">Short-term or emergency accommodation</option>
                                    <option value="9">Not stated/inadequately described</option>
                                  </Form.Control>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>Labour Force Status *</Form.Label>
                                  <Form.Control as="select" name="labour" value={values.labour} onChange={change.bind(null, "labour")}>
                                    <option value="1">Employed</option>
                                    <option value="2">Unemployed</option>
                                    <option value="3">Not in the labour force</option>
                                    <option value="9">Not stated/inadequately described</option>
                                  </Form.Control>
                                </Form.Group>
                              </Col>
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>LGBTIQA+ Status *</Form.Label>
                                  <Form.Control as="select" name="lgbtiqa" value={values.lgbtiqa} onChange={change.bind(null, "lgbtiqa")}>
                                    <option value="1">Straight / Heterosexual</option>
                                    <option value="2">Gay or lesbian</option>
                                    <option value="3">Bisexual</option>
                                    <option value="4">Different term</option>
                                    <option value="5">Don't know</option>
                                    <option value="6">Prefer not to answer</option>
                                  </Form.Control>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>Highest Education Level Achieved *</Form.Label>
                                  <Form.Control as="select" name="education" value={values.education} onChange={change.bind(null, "education")}>
                                    <option value="6">Secondary education</option>
                                    <option value="7">Primary education</option>
                                    <option value="1">Postgraduate degree level</option>
                                    <option value="2">Graduate diploma and Graduate Certificate level</option>
                                    <option value="3">Bachelor degree level</option>
                                    <option value="4">Advanced diploma and diploma level</option>
                                    <option value="5">Certificate level</option>
                                    <option value="8">Pre-primary education</option>
                                    <option value="9">Other education</option>
                                  </Form.Control>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>Disability Status *</Form.Label>
                                  <Form.Control
                                    as="select"
                                    name="disabilityStatus"
                                    value={values.disabilityStatus}
                                    onChange={change.bind(null, "disabilityStatus")}
                                  >
                                    <option value="No">No</option>
                                    <option value="Yes">Yes</option>
                                  </Form.Control>
                                </Form.Group>
                              </Col>
                              {values.disabilityStatus === "Yes" ? (
                                <Col md="6">
                                  <Form.Group>
                                    <Form.Label>Disability Type</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="disabilityType"
                                      value={values.disabilityType}
                                      onChange={change.bind(null, "disabilityType")}
                                      autoComplete="new-password"
                                      isInvalid={touched.disabilityType && !!errors.disabilityType}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.disabilityType}</Form.Control.Feedback>
                                  </Form.Group>
                                </Col>
                              ) : null}
                            </Row>
                            <Row>
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>Country of Birth *</Form.Label>
                                  <Autocomplete
                                    id="countryofbirth"
                                    variant="outlined"
                                    options={countries}
                                    getOptionLabel={(option) => option.countryName}
                                    value={countries.find((v) => String(v.countryCode) === String(values.birthCountry)) || null}
                                    onChange={(e, value) => {
                                      setFieldValue("birthCountry", value.countryCode);
                                    }}
                                    style={{
                                      fullWidth: true,
                                      display: "flex",
                                      wrap: "nowrap",
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        type="text"
                                        variant="outlined"
                                        margin="dense"
                                        name="CountryOfBirthSelector"
                                        style={{
                                          backgroundColor: "white",
                                          margin: 0,
                                          padding: 0,
                                        }}
                                        inputProps={{
                                          ...params.inputProps,
                                          autoComplete: "new-password",
                                        }}
                                      />
                                    )}
                                    autoComplete="new-password"
                                  />
                                </Form.Group>
                              </Col>
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>Main Language Spoken at Home *</Form.Label>
                                  <Autocomplete
                                    id="languageathome"
                                    variant="outlined"
                                    options={languages}
                                    getOptionLabel={(option) => option.languageName}
                                    value={languages.find((v) => String(v.languageCode) === String(values.language)) || null}
                                    onChange={(e, value) => {
                                      setFieldValue("language", value.languageCode);
                                    }}
                                    style={{
                                      fullWidth: true,
                                      display: "flex",
                                      wrap: "nowrap",
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        type="text"
                                        variant="outlined"
                                        margin="dense"
                                        name="LanguageAtHomeSelector"
                                        style={{
                                          backgroundColor: "white",
                                          margin: 0,
                                          padding: 0,
                                        }}
                                        inputProps={{
                                          ...params.inputProps,
                                          autoComplete: "new-password",
                                        }}
                                      />
                                    )}
                                    autoComplete="new-password"
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>English Proficiency *</Form.Label>
                                  <Form.Control as="select" name="proficiency" value={values.proficiency} onChange={change.bind(null, "proficiency")}>
                                    <option value="0">Not applicable (persons under 5 years of age or who speak only English)</option>
                                    <option value="1">Very well</option>
                                    <option value="2">Well</option>
                                    <option value="3">Not well</option>
                                    <option value="4">Not at all</option>
                                    <option value="9">Not stated/inadequately described</option>
                                  </Form.Control>
                                </Form.Group>
                              </Col>
                            </Row>
                          </>
                        ) : null}
                      </Tab>
                      <Tab
                        eventKey="Notes"
                        title="Notes"
                        style={{
                          backgroundColor: "rgb(245, 245, 245)",
                          padding: 6,
                        }}
                      >
                        {client && client.id !== 0 ? (
                          <Notes
                            type="Client"
                            firstName={values.preferredname && values.preferredname.length > 2 ? values.preferredname : values.firstname}
                            pkid={values.id}
                            waitingRoomURL={values.waitingRoomURL}
                            ownerName={
                              csAgents && csAgents.some((agent) => agent.id === values.ownerid)
                                ? csAgents.find((agent) => agent.id === values.ownerid).firstname
                                : ""
                            }
                            email={values.email}
                            mobilephone={values.mobilephone}
                            viewType="NoteOnly"
                            specialistType="centralisedservice"
                          />
                        ) : null}
                      </Tab>
                      <Tab
                        eventKey="Bookings"
                        title="Bookings"
                        style={{
                          backgroundColor: "rgb(245, 245, 245)",
                          padding: 6,
                        }}
                      >
                        {client && client.id !== 0 ? (
                          <BookingsList
                            type="client"
                            id={values.id}
                            userTZ={values.timezone}
                            view="admin"
                            providerType={props.type}
                            specialistType="centralisedservice"
                          />
                        ) : null}
                      </Tab>
                      <Tab
                        eventKey="ClientScores"
                        title="Scores"
                        style={{
                          backgroundColor: "rgb(245, 245, 245)",
                          padding: 6,
                        }}
                      >
                        {client && client.id !== 0 ? <ClientScores clientID={values.id} /> : null}
                      </Tab>
                      <Tab
                        eventKey="Communications"
                        title="Communications"
                        style={{
                          backgroundColor: "rgb(245, 245, 245)",
                          padding: 6,
                        }}
                      >
                        {client && client.id !== 0 ? (
                          <Notes
                            type="Client"
                            firstName={values.preferredname && values.preferredname.length > 2 ? values.preferredname : values.firstname}
                            pkid={values.id}
                            waitingRoomURL={values.waitingRoomURL}
                            specialistType={"centralisedservice"}
                            ownerName={
                              csAgents && csAgents.some((agent) => agent.id === values.ownerid)
                                ? csAgents.find((agent) => agent.id === values.ownerid).firstname
                                : ""
                            }
                            email={values.email}
                            mobilephone={values.mobilephone}
                          />
                        ) : null}
                      </Tab>
                      <Tab
                        eventKey="Files"
                        title="Files"
                        style={{
                          backgroundColor: "rgb(245, 245, 245)",
                          padding: 6,
                        }}
                      >
                        {client && client.id !== 0 ? (
                          <Files type="Client" subtype={values.paymentType} pkid={values.id} specialistType="centralisedservice" />
                        ) : null}
                      </Tab>
                      {/* 
                        <Tab eventKey="security" title="Security" style={{backgroundColor: "rgb(245, 245, 245)", padding: 6}}>
                          {client && client.id !== 0 ?
                            <>
                              <Row>
                                <Col md="3">
                                  <Form.Group >
                                    <Form.Label>New Password</Form.Label>
                                    <Form.Control type="password" name="newpassword" defaultValue={currentNewPassword} onBlur={(event) => setcurrentNewPassword(event.target.value)} autoComplete='new-password' />
                                  </Form.Group>
                                </Col>
                                <Col md="3"> 
                                  <Form.Group >
                                  <Form.Label>New Confirm Password</Form.Label>
                                    <Form.Control type="password" name="newpasswordconfirmation" defaultValue={currentNewPasswordConfirmation} onBlur={(event) => setcurrentNewPasswordConfirmation(event.target.value)} autoComplete='new-password' />
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col md="5">
                                  <Form.Group>
                                    <span style={{ paddingBottom: 4 }}>Force Password Change at Next Login</span>
                                    <Checkbox aria-label='Force Password Change at Next Login' name="ForcePasswordChange" value={currentForcePasswordChange} onChange={(event) => setcurrentForcePasswordChange(event.target.checked)} style={{ paddingTop: 6, paddingLeft: 15 }}    />
                                  </Form.Group>
                                </Col>
                              </Row> *
                            </>
                          :
                            null
                          }
                        </Tab> 
                      */}
                      <Tab
                        eventKey="audit"
                        title="Audit"
                        style={{
                          backgroundColor: "rgb(245, 245, 245)",
                          padding: 6,
                        }}
                      >
                        <AuditLog clientID={values.id} />
                      </Tab>
                    </Tabs>
                    {Object.keys(errors).length > 0 && (
                      <div
                        style={{
                          backgroundColor: "#f8d7da",
                          border: "1px solid #f5c2c7",
                          borderRadius: "6px",
                          padding: "12px 16px",
                          margin: "12px 0",
                          color: "#842029",
                        }}
                      >
                        <strong>Please fix the following errors:</strong>
                        <ul style={{ marginBottom: 0, marginTop: "8px" }}>
                          {Object.entries(errors).map(([field, message]) => (
                            <li key={field}>
                              <strong>{fieldLabels[field] || field}:</strong> {message}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </Paper>
                </Modal.Body>
                <Modal.Footer className="editprofile-modal">
                  <Button variant="secondary" onClick={handleClose}>
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    type="submit"
                    disabled={
                      client &&
                      client.id === 0 &&
                      (!consentAccepted ||
                        (consentAccepted && values.csConsent === "") ||
                        (values.csConsent === "FormNow" && (consentFormData === null || consentFormData === undefined || consentFormData === "")))
                    }
                  >
                    {client && client.id === 0 && (!consentAccepted || (consentAccepted && values.csConsent === ""))
                      ? "Unable to Save - Consent Not Set"
                      : client &&
                          client.id === 0 &&
                          values.csConsent === "FormNow" &&
                          (consentFormData === null || consentFormData === undefined || consentFormData === "")
                        ? "Unable to Save - Consent Form Not Signed"
                        : "Save"}
                  </Button>
                </Modal.Footer>
              </form>
            );
          }}
        </Formik>
      </Modal>

      <Modal show={showConsentForm} onHide={() => setShowConsentForm(false)} dialogClassName="edit-md-sm-dialog-modal">
        <Modal.Header className="edit-md-sm-modal">
          <Modal.Title>Consent</Modal.Title>
          <Button
            variant="outlined"
            size="sm"
            style={{
              marginTop: 5,
              background: "#eeeeee",
              border: "1px solid #9da8e5",
              padding: 5,
              marginLeft: 10,
            }}
            onClick={() => setShowConsentForm(false)}
          >
            <CloseIcon />
          </Button>
        </Modal.Header>
        <Modal.Body className="edit-md-modal">
          {process.env.REACT_APP_ENV === "dev" ? (
            <FormDataEntry
              formID={14357}
              formDataID={0}
              setShowFormData={setShowConsentForm}
              setFormData={setConsentFormData}
              consent={true}
              setResetConsent={setResetConsent}
              contextName="ConsentMaintenance"
              contextID={thisClient && thisClient.id}
            />
          ) : (
            <FormDataEntry
              formID={14357}
              formDataID={0}
              setShowFormData={setShowConsentForm}
              setFormData={setConsentFormData}
              consent={true}
              setResetConsent={setResetConsent}
              contextName="ConsentMaintenance"
              contextID={thisClient && thisClient.id}
            />
          )}
        </Modal.Body>
      </Modal>

      <Modal show={showAppointment} onHide={handleAppointmentClose} dialogClassName="editappointment-modal">
        <Modal.Header closeButton className="editappointment-modal">
          <Modal.Title>
            Appointments - {currentFirstName} {currentSurname}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="editappointment-modal">
          <BookingWeek
            mode="admin"
            clientID={currentClientID}
            clientFullname={
              currentFirstName &&
              (currentPreferredName && currentPreferredName.length > 2 ? currentPreferredName + " " + currentSurname : currentFirstName + " " + currentSurname)
            }
            clientFirstName={currentFirstName}
            clientPreferredName={currentPreferredName}
            clientEmail={currentEmail}
            clientTZ={currentTimeZone}
            paymentType={currentPaymentType}
            bookingType={currentClientBookingType}
            providerType="CentralisedService"
            setShowAppointment={setShowAppointment}
            specialistType="centralisedservice"
            clientPsychologistProviderID={currentProviderPsychologistID}
            clientPsychiatristProviderID={currentProviderPsychiatristID}
          />
        </Modal.Body>
        <Modal.Footer className="editappointment-modal">
          <Button variant="secondary" onClick={handleAppointmentClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showBooking} onHide={() => setShowBooking(false)} dialogClassName="new-bookingDialog-modal" centered>
        <Modal.Header closeButton className="new-booking-modal">
          {clientBooking && clientBooking.id ? (
            <Modal.Title>Booking - {clientBooking.status}</Modal.Title>
          ) : (
            <Modal.Title>Retrieving Booking Information - Please wait </Modal.Title>
          )}
        </Modal.Header>
        <Modal.Body>
          {!toggleMessage ? (
            <Grid container spacing={3} style={{ height: 247 }}>
              <Grid item md={3} xs={6}>
                Psychologist:
              </Grid>
              <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                {clientBooking.psychologistfullname}
              </Grid>
              <Grid item md={3} xs={6}>
                Client:
              </Grid>
              <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                {clientBooking.clientfullname}
              </Grid>
              <Grid item md={3} xs={6}>
                Date:
              </Grid>
              <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                {format(new Date(clientBooking.clientDate ? clientBooking.clientDate : null), "dd/MM/yyyy")}
              </Grid>
              <Grid item md={3} xs={6}>
                Time:
              </Grid>
              <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                {format(new Date(clientBooking.clientDate ? clientBooking.clientDate : null), "h:mm aa")}
              </Grid>
              <Grid item md={3} xs={6}>
                Location:
              </Grid>
              <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                {clientBooking.bookingLocation}
              </Grid>
              <Grid item md={3} xs={6}>
                Session Type:
              </Grid>
              <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                {clientBooking.bookingCode}
              </Grid>
              <Grid item md={3} xs={6}>
                Booking Type:
              </Grid>
              <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                {clientBooking.bookingType}
              </Grid>
              {clientBooking.waitingroomurl && clientBooking.waitingroomurl.length > 2 ? (
                <>
                  <Grid item md={3} xs={6}>
                    Booking Link:
                  </Grid>
                  <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                    <Typography style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
                      <CopyIcon onClick={() => navigator.clipboard.writeText(clientBooking.waitingroomurl)} style={{ marginRight: 10 }} />
                      <a
                        href={clientBooking.waitingroomurl}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "inherit", textDecoration: "none" }} // optional: makes link look like text
                      >
                        {clientBooking.waitingroomurl}
                      </a>
                    </Typography>
                  </Grid>
                </>
              ) : null}
            </Grid>
          ) : sentMsg ? (
            <>
              <Row>
                <Col md="12" style={{ height: 222 }}>
                  {sentMsg}
                </Col>
              </Row>
            </>
          ) : (
            <>
              <Row>
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={8}
                      type="text"
                      name="psychologistNote"
                      defaultValue={newNote}
                      onBlur={(event) => setNewNote(event.target.value)}
                      autoComplete="new-password"
                      style={{ borderColor: "#D1D1D1" }}
                    />
                    {/* {newNoteHelpText.length ? (<p className='error-help'>{newNoteHelpText}</p>) : ''} */}
                  </Form.Group>
                </Col>
              </Row>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            {!toggleMessage ? (
              <>
                {clientBooking && clientBooking.id ? (
                  <>
                    <Grid item>{getActionButtons(clientBooking.id)}</Grid>
                    <Grid item>
                      <Button variant="primary" size="sm" onClick={() => setToggleMessage(!toggleMessage)} style={{ marginRight: 15 }}>
                        Message
                      </Button>
                      <Button variant="secondary" size="sm" onClick={() => setShowBooking(false)} className="lightButtonOutlinedLarge">
                        Close
                      </Button>
                    </Grid>
                  </>
                ) : (
                  <Grid item>
                    <Button variant="secondary" size="sm" onClick={() => setShowBooking(false)} className="lightButtonOutlinedLarge">
                      Close
                    </Button>
                  </Grid>
                )}
              </>
            ) : (
              <>
                <Grid item>
                  <Button variant="secondary" size="sm" onClick={() => setToggleMessage(!toggleMessage)} className="lightButtonOutlinedLarge">
                    Cancel
                  </Button>
                </Grid>
                <Grid item>
                  <Button variant="success" size="sm" onClick={() => sendMessage()}>
                    Send &gt;
                  </Button>
                </Grid>
              </>
            )}
          </Grid>
        </Modal.Footer>
      </Modal>

      <Modal show={showNotes} onHide={() => setShowNotes(false)} dialogClassName="notes-modal-dialog">
        <Modal.Header closeButton className="notes-modal">
          <Modal.Title>
            {currentNotesViewType === "NoteOnly" ? `Notes - ${currentFirstName} ${currentSurname}` : `Communications - ${currentFirstName} ${currentSurname}`}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="notes-modal">
          <Notes
            type="Client"
            pkid={currentClientID}
            waitingRoomURL={currentwaitingRoomURL}
            firstName={currentPreferredName && currentPreferredName.length > 2 ? currentPreferredName : currentFirstName}
            viewType={currentNotesViewType}
            ownerName={currentOwnerName}
            email={currentEmail}
            mobilephone={currentMobilePhone}
            specialistType="centralisedservice"
          />
        </Modal.Body>
        <Modal.Footer className="notes-modal">
          <Button variant="secondary" onClick={() => setShowNotes(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showLink} onHide={() => setShowLink(false)} dialogClassName="notes-modal-dialog">
        <Modal.Header closeButton className="notes-modal">
          <Modal.Title>
            Email/SMS Meeting Link to {currentFirstName} {currentSurname}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="notes-modal">
          <BookingLink
            type="Client"
            pkid={currentClientID}
            waitingRoomURL={currentwaitingRoomURL}
            setShowLink={setShowLink}
            firstName={currentPreferredName && currentPreferredName.length > 2 ? currentPreferredName : currentFirstName}
            providerName={currentProviderName}
            clientBooking={currentClientBooking}
            email={currentEmail}
            mobilephone={currentMobilePhone}
          />
        </Modal.Body>
        <Modal.Footer className="notes-modal">
          <Button variant="secondary" onClick={() => setShowLink(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showFiles} onHide={() => setShowFiles(false)} dialogClassName="notes-modal-dialog">
        <Modal.Header closeButton className="notes-modal">
          <Modal.Title>
            Files - {currentFirstName} {currentSurname}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="notes-modal">
          {actualRegistered ? <Files type="Client" subtype={currentPaymentType} pkid={currentClientID} specialistType="centralisedservice" /> : null}
        </Modal.Body>
        <Modal.Footer className="notes-modal">
          <Button variant="secondary" onClick={() => setShowFiles(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showOwner} onHide={() => setShowOwner(false)} dialogClassName="new-bookingDialog-modal" backdrop="static" keyboard={false} centered>
        <Modal.Header closeButton>
          <Modal.Title>Client's Centre Contact Person</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "rgb(245,245,245)" }}>
          <Grid container spacing={2}>
            <Grid item md={3} xs={6}>
              Name:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {currentOwnerName}
            </Grid>
            <Grid item md={3} xs={6}>
              Email:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {currentOwnerEmail}
            </Grid>
            <Grid item md={3} xs={6}>
              Phone:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {currentOwnerPhone}
            </Grid>
          </Grid>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowOwner(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showClose} onHide={handleCloseClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            Close Client - {currentFirstName} {currentSurname}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>
            As part of closing the engagement with the client:{" "}
            <strong>
              {currentFirstName} {currentSurname}
            </strong>
            ?
          </p>
          <p>Please select which forms to send to the client as part of the closure process.</p>

          <Form>
            <Form.Group>
              <FormControlLabel
                control={<Switch checked={currentSurveyRequired} onChange={(e) => setcurrentSurveyRequired(e.target.checked)} color="primary" />}
                label="Send Client CS Survey"
              />
            </Form.Group>

            <Form.Group>
              <FormControlLabel
                control={<Switch checked={currentK10Required} onChange={(e) => handleK10Toggle(e.target.checked)} color="primary" />}
                label="Send K10 Form"
              />
            </Form.Group>

            <Form.Group>
              <FormControlLabel
                control={<Switch checked={currentK5Required} onChange={(e) => handleK5Toggle(e.target.checked)} color="primary" />}
                label="Send K5 Form"
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => closeClientUpdate(currentClientID, currentFirstName, currentEmail, currentSurveyRequired, currentK10Required, currentK5Required)}
          >
            Archive Client
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showAttendanceDialog}
        onHide={() => setShowAttendanceDialog(false)}
        size="lg" // "sm" | "lg" | "xl"
        dialogClassName="note-modal"
        style={{ zIndex: 1150 }}
        centered
      >
        <Modal.Header closeButton className="notes-modal">
          <Modal.Title>Booking with {clientBooking && clientBooking.clientfullname ? clientBooking.clientfullname : ""}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="notes-modal" style={{ backgroundColor: "rgb(245,245,245)" }}>
          <BookingOutcome
            name={clientBooking && clientBooking.clientfullname ? clientBooking.clientfullname : ""}
            start={clientBooking && clientBooking.psychologistDate ? clientBooking.psychologistDate : null}
            status={clientBooking && clientBooking.status ? clientBooking.status : ""}
            clientID={clientBooking && clientBooking.clientID ? clientBooking.clientID : null}
            bookingID={clientBooking && clientBooking.id ? clientBooking.id : null}
            paymentType={"Contract"}
            psychologistID={clientBooking && clientBooking.psychologistID ? clientBooking.psychologistID : null}
            closeModal={setShowAttendanceDialog}
            attendanceStatus={new Date(clientBooking && clientBooking.psychologistDate) < new Date() ? "Past" : "Upcoming"}
          />
        </Modal.Body>
      </Modal>

      <ToastContainer
        position="bottom-right"
        transition={Flip}
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}
